// source: proto/reportpb/activity.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global = Function('return this')();

var google_protobuf_timestamp_pb = require('google-protobuf/google/protobuf/timestamp_pb.js');
goog.object.extend(proto, google_protobuf_timestamp_pb);
var google_type_date_pb = require('../../google/type/date_pb.js');
goog.object.extend(proto, google_type_date_pb);
var proto_commonpb_file_pb = require('../../proto/commonpb/file_pb.js');
goog.object.extend(proto, proto_commonpb_file_pb);
var proto_utilspb_pagination_pb = require('../../proto/utilspb/pagination_pb.js');
goog.object.extend(proto, proto_utilspb_pagination_pb);
goog.exportSymbol('proto.reportpb.Activity', null, global);
goog.exportSymbol('proto.reportpb.ActivityReportDetails', null, global);
goog.exportSymbol('proto.reportpb.DownloadTradeConfirmationRequest', null, global);
goog.exportSymbol('proto.reportpb.ListActivitiesResponse', null, global);
goog.exportSymbol('proto.reportpb.ListActivityReportDetailsRequest', null, global);
goog.exportSymbol('proto.reportpb.ListActivityRequest', null, global);
goog.exportSymbol('proto.reportpb.ListActivityResponse', null, global);
goog.exportSymbol('proto.reportpb.ListActivitySummary', null, global);
goog.exportSymbol('proto.reportpb.PageViewActivityRequest', null, global);
goog.exportSymbol('proto.reportpb.UpdateActivityRequest', null, global);
goog.exportSymbol('proto.reportpb.UpdateActivityResponse', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.reportpb.Activity = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.reportpb.Activity.repeatedFields_, null);
};
goog.inherits(proto.reportpb.Activity, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.reportpb.Activity.displayName = 'proto.reportpb.Activity';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.reportpb.ActivityReportDetails = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.reportpb.ActivityReportDetails, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.reportpb.ActivityReportDetails.displayName = 'proto.reportpb.ActivityReportDetails';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.reportpb.ListActivityReportDetailsRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.reportpb.ListActivityReportDetailsRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.reportpb.ListActivityReportDetailsRequest.displayName = 'proto.reportpb.ListActivityReportDetailsRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.reportpb.ListActivityRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.reportpb.ListActivityRequest.repeatedFields_, null);
};
goog.inherits(proto.reportpb.ListActivityRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.reportpb.ListActivityRequest.displayName = 'proto.reportpb.ListActivityRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.reportpb.PageViewActivityRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.reportpb.PageViewActivityRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.reportpb.PageViewActivityRequest.displayName = 'proto.reportpb.PageViewActivityRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.reportpb.ListActivityResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.reportpb.ListActivityResponse.repeatedFields_, null);
};
goog.inherits(proto.reportpb.ListActivityResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.reportpb.ListActivityResponse.displayName = 'proto.reportpb.ListActivityResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.reportpb.DownloadTradeConfirmationRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.reportpb.DownloadTradeConfirmationRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.reportpb.DownloadTradeConfirmationRequest.displayName = 'proto.reportpb.DownloadTradeConfirmationRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.reportpb.ListActivitySummary = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.reportpb.ListActivitySummary.repeatedFields_, null);
};
goog.inherits(proto.reportpb.ListActivitySummary, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.reportpb.ListActivitySummary.displayName = 'proto.reportpb.ListActivitySummary';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.reportpb.UpdateActivityRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.reportpb.UpdateActivityRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.reportpb.UpdateActivityRequest.displayName = 'proto.reportpb.UpdateActivityRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.reportpb.UpdateActivityResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.reportpb.UpdateActivityResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.reportpb.UpdateActivityResponse.displayName = 'proto.reportpb.UpdateActivityResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.reportpb.ListActivitiesResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.reportpb.ListActivitiesResponse.repeatedFields_, null);
};
goog.inherits(proto.reportpb.ListActivitiesResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.reportpb.ListActivitiesResponse.displayName = 'proto.reportpb.ListActivitiesResponse';
}

/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.reportpb.Activity.repeatedFields_ = [100];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.reportpb.Activity.prototype.toObject = function(opt_includeInstance) {
  return proto.reportpb.Activity.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.reportpb.Activity} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.reportpb.Activity.toObject = function(includeInstance, msg) {
  var f, obj = {
    correspondent: jspb.Message.getFieldWithDefault(msg, 1, ""),
    accountNo: jspb.Message.getFieldWithDefault(msg, 2, ""),
    accountName: jspb.Message.getFieldWithDefault(msg, 3, ""),
    masterAccountNo: jspb.Message.getFieldWithDefault(msg, 4, ""),
    effSettleDate: (f = msg.getEffSettleDate()) && google_type_date_pb.Date.toObject(includeInstance, f),
    broker: jspb.Message.getFieldWithDefault(msg, 6, ""),
    type: jspb.Message.getFieldWithDefault(msg, 7, ""),
    capacity: jspb.Message.getFieldWithDefault(msg, 8, ""),
    effTradeDate: (f = msg.getEffTradeDate()) && google_type_date_pb.Date.toObject(includeInstance, f),
    symbol: jspb.Message.getFieldWithDefault(msg, 10, ""),
    symbolDescription: jspb.Message.getFieldWithDefault(msg, 11, ""),
    cusip: jspb.Message.getFieldWithDefault(msg, 12, ""),
    assetType: jspb.Message.getFieldWithDefault(msg, 13, ""),
    createdAt: (f = msg.getCreatedAt()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
    systemDate: (f = msg.getSystemDate()) && google_type_date_pb.Date.toObject(includeInstance, f),
    tradeDate: (f = msg.getTradeDate()) && google_type_date_pb.Date.toObject(includeInstance, f),
    tradeAt: (f = msg.getTradeAt()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
    settleDate: (f = msg.getSettleDate()) && google_type_date_pb.Date.toObject(includeInstance, f),
    entryType: jspb.Message.getFieldWithDefault(msg, 19, ""),
    side: jspb.Message.getFieldWithDefault(msg, 20, ""),
    qty: jspb.Message.getFieldWithDefault(msg, 21, ""),
    price: jspb.Message.getFieldWithDefault(msg, 22, ""),
    grossAmt: jspb.Message.getFieldWithDefault(msg, 23, ""),
    regFee: jspb.Message.getFieldWithDefault(msg, 24, ""),
    tafFee: jspb.Message.getFieldWithDefault(msg, 25, ""),
    fees: jspb.Message.getFieldWithDefault(msg, 26, ""),
    netAmt: jspb.Message.getFieldWithDefault(msg, 27, ""),
    description: jspb.Message.getFieldWithDefault(msg, 28, ""),
    batchNo: jspb.Message.getFieldWithDefault(msg, 29, ""),
    status: jspb.Message.getFieldWithDefault(msg, 30, ""),
    createdBy: jspb.Message.getFieldWithDefault(msg, 31, ""),
    trnsId: jspb.Message.getFieldWithDefault(msg, 32, 0),
    accountId: jspb.Message.getFieldWithDefault(msg, 33, 0),
    executingVenue: jspb.Message.getFieldWithDefault(msg, 34, ""),
    externalId: jspb.Message.getFieldWithDefault(msg, 35, ""),
    orderId: jspb.Message.getFieldWithDefault(msg, 36, ""),
    vendor: jspb.Message.getFieldWithDefault(msg, 37, ""),
    contraAccountNo: jspb.Message.getFieldWithDefault(msg, 38, ""),
    commission: jspb.Message.getFieldWithDefault(msg, 39, ""),
    contraCorrespondent: jspb.Message.getFieldWithDefault(msg, 40, ""),
    contraAccountId: jspb.Message.getFieldWithDefault(msg, 41, 0),
    originalCusip: jspb.Message.getFieldWithDefault(msg, 42, ""),
    entryTypeDescription: jspb.Message.getFieldWithDefault(msg, 43, ""),
    rep: jspb.Message.getFieldWithDefault(msg, 44, ""),
    branch: jspb.Message.getFieldWithDefault(msg, 45, ""),
    compressType: jspb.Message.getFieldWithDefault(msg, 46, ""),
    compressCount: jspb.Message.getFieldWithDefault(msg, 47, 0),
    compressId: jspb.Message.getFieldWithDefault(msg, 48, 0),
    traderId: jspb.Message.getFieldWithDefault(msg, 49, ""),
    referenceId: jspb.Message.getFieldWithDefault(msg, 50, ""),
    previousTrnsId: jspb.Message.getFieldWithDefault(msg, 51, 0),
    product: jspb.Message.getFieldWithDefault(msg, 52, ""),
    accrual: jspb.Message.getFieldWithDefault(msg, 53, ""),
    couponRate: jspb.Message.getFieldWithDefault(msg, 54, ""),
    interestPayment: jspb.Message.getFieldWithDefault(msg, 55, ""),
    yield: jspb.Message.getFieldWithDefault(msg, 56, ""),
    orgType: jspb.Message.getFieldWithDefault(msg, 57, ""),
    orgTerm: (f = msg.getOrgTerm()) && google_type_date_pb.Date.toObject(includeInstance, f),
    sameDayCancel: jspb.Message.getBooleanFieldWithDefault(msg, 59, false),
    contraBroker: jspb.Message.getFieldWithDefault(msg, 60, ""),
    taxWithholding: jspb.Message.getFieldWithDefault(msg, 61, ""),
    multiplier: jspb.Message.getFieldWithDefault(msg, 62, ""),
    contraSubAccountNo: jspb.Message.getFieldWithDefault(msg, 63, ""),
    subAccountNo: jspb.Message.getFieldWithDefault(msg, 64, ""),
    otherFees: jspb.Message.getFieldWithDefault(msg, 65, ""),
    year: jspb.Message.getFieldWithDefault(msg, 66, ""),
    participantNo: jspb.Message.getFieldWithDefault(msg, 67, ""),
    asOfDate: (f = msg.getAsOfDate()) && google_type_date_pb.Date.toObject(includeInstance, f),
    registeredAdvisorCapacity: jspb.Message.getFieldWithDefault(msg, 69, ""),
    specialRemarks: jspb.Message.getFieldWithDefault(msg, 70, ""),
    timeOfExecution: (f = msg.getTimeOfExecution()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
    principal: jspb.Message.getFieldWithDefault(msg, 72, ""),
    miscFee: jspb.Message.getFieldWithDefault(msg, 73, ""),
    otherFees2: jspb.Message.getFieldWithDefault(msg, 74, ""),
    location: jspb.Message.getFieldWithDefault(msg, 75, ""),
    discretion: jspb.Message.getFieldWithDefault(msg, 76, ""),
    currency: jspb.Message.getFieldWithDefault(msg, 77, ""),
    currencyRate: jspb.Message.getFieldWithDefault(msg, 78, ""),
    currencyAmt: jspb.Message.getFieldWithDefault(msg, 79, ""),
    execId: jspb.Message.getFieldWithDefault(msg, 80, ""),
    legId: jspb.Message.getFieldWithDefault(msg, 81, ""),
    settlementMethod: jspb.Message.getFieldWithDefault(msg, 82, ""),
    isSolicited: jspb.Message.getBooleanFieldWithDefault(msg, 83, false),
    stepIndicator: jspb.Message.getBooleanFieldWithDefault(msg, 84, false),
    comparisonIndicator: jspb.Message.getBooleanFieldWithDefault(msg, 85, false),
    noRemuneration: jspb.Message.getBooleanFieldWithDefault(msg, 86, false),
    whenIssue: jspb.Message.getBooleanFieldWithDefault(msg, 87, false),
    newIssue: jspb.Message.getBooleanFieldWithDefault(msg, 88, false),
    isMsrb: jspb.Message.getBooleanFieldWithDefault(msg, 89, false),
    isCorp: jspb.Message.getBooleanFieldWithDefault(msg, 90, false),
    ytc: jspb.Message.getFieldWithDefault(msg, 91, ""),
    ytm: jspb.Message.getFieldWithDefault(msg, 92, ""),
    markAmount: jspb.Message.getFieldWithDefault(msg, 93, ""),
    pmp: jspb.Message.getFieldWithDefault(msg, 94, ""),
    markRate: jspb.Message.getFieldWithDefault(msg, 95, ""),
    atsIdentifier: jspb.Message.getFieldWithDefault(msg, 96, ""),
    currencyGrossAmt: jspb.Message.getFieldWithDefault(msg, 97, ""),
    currencyFees: jspb.Message.getFieldWithDefault(msg, 98, ""),
    otherFeeValuesList: (f = jspb.Message.getRepeatedField(msg, 100)) == null ? undefined : f,
    euroclearId: jspb.Message.getFieldWithDefault(msg, 101, ""),
    settlementInstructionId: jspb.Message.getFieldWithDefault(msg, 102, 0),
    orderType: jspb.Message.getFieldWithDefault(msg, 103, ""),
    accountType: jspb.Message.getFieldWithDefault(msg, 104, ""),
    contraBrokerNo: jspb.Message.getFieldWithDefault(msg, 105, ""),
    marginType: jspb.Message.getFieldWithDefault(msg, 106, ""),
    subAccountType: jspb.Message.getFieldWithDefault(msg, 107, 0),
    otherFeesList: jspb.Message.getFieldWithDefault(msg, 108, ""),
    dvpConfirmNo: jspb.Message.getFieldWithDefault(msg, 109, 0),
    isOpenItem: jspb.Message.getBooleanFieldWithDefault(msg, 110, false),
    dvpExternalId: jspb.Message.getFieldWithDefault(msg, 111, ""),
    isArchived: jspb.Message.getBooleanFieldWithDefault(msg, 112, false),
    internalNote: jspb.Message.getFieldWithDefault(msg, 113, ""),
    effAtlTradeDate: (f = msg.getEffAtlTradeDate()) && google_type_date_pb.Date.toObject(includeInstance, f),
    effAtlSettleDate: (f = msg.getEffAtlSettleDate()) && google_type_date_pb.Date.toObject(includeInstance, f),
    source: jspb.Message.getFieldWithDefault(msg, 116, ""),
    executionQty: jspb.Message.getFieldWithDefault(msg, 117, ""),
    executionNetAmt: jspb.Message.getFieldWithDefault(msg, 118, ""),
    reportActivityId: jspb.Message.getFieldWithDefault(msg, 119, 0),
    ctmPartyValue: jspb.Message.getFieldWithDefault(msg, 120, ""),
    masterReference: jspb.Message.getFieldWithDefault(msg, 121, ""),
    repoRate: jspb.Message.getFieldWithDefault(msg, 122, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.reportpb.Activity}
 */
proto.reportpb.Activity.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.reportpb.Activity;
  return proto.reportpb.Activity.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.reportpb.Activity} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.reportpb.Activity}
 */
proto.reportpb.Activity.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setCorrespondent(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setAccountNo(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setAccountName(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setMasterAccountNo(value);
      break;
    case 5:
      var value = new google_type_date_pb.Date;
      reader.readMessage(value,google_type_date_pb.Date.deserializeBinaryFromReader);
      msg.setEffSettleDate(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setBroker(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.setType(value);
      break;
    case 8:
      var value = /** @type {string} */ (reader.readString());
      msg.setCapacity(value);
      break;
    case 9:
      var value = new google_type_date_pb.Date;
      reader.readMessage(value,google_type_date_pb.Date.deserializeBinaryFromReader);
      msg.setEffTradeDate(value);
      break;
    case 10:
      var value = /** @type {string} */ (reader.readString());
      msg.setSymbol(value);
      break;
    case 11:
      var value = /** @type {string} */ (reader.readString());
      msg.setSymbolDescription(value);
      break;
    case 12:
      var value = /** @type {string} */ (reader.readString());
      msg.setCusip(value);
      break;
    case 13:
      var value = /** @type {string} */ (reader.readString());
      msg.setAssetType(value);
      break;
    case 14:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setCreatedAt(value);
      break;
    case 15:
      var value = new google_type_date_pb.Date;
      reader.readMessage(value,google_type_date_pb.Date.deserializeBinaryFromReader);
      msg.setSystemDate(value);
      break;
    case 16:
      var value = new google_type_date_pb.Date;
      reader.readMessage(value,google_type_date_pb.Date.deserializeBinaryFromReader);
      msg.setTradeDate(value);
      break;
    case 17:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setTradeAt(value);
      break;
    case 18:
      var value = new google_type_date_pb.Date;
      reader.readMessage(value,google_type_date_pb.Date.deserializeBinaryFromReader);
      msg.setSettleDate(value);
      break;
    case 19:
      var value = /** @type {string} */ (reader.readString());
      msg.setEntryType(value);
      break;
    case 20:
      var value = /** @type {string} */ (reader.readString());
      msg.setSide(value);
      break;
    case 21:
      var value = /** @type {string} */ (reader.readString());
      msg.setQty(value);
      break;
    case 22:
      var value = /** @type {string} */ (reader.readString());
      msg.setPrice(value);
      break;
    case 23:
      var value = /** @type {string} */ (reader.readString());
      msg.setGrossAmt(value);
      break;
    case 24:
      var value = /** @type {string} */ (reader.readString());
      msg.setRegFee(value);
      break;
    case 25:
      var value = /** @type {string} */ (reader.readString());
      msg.setTafFee(value);
      break;
    case 26:
      var value = /** @type {string} */ (reader.readString());
      msg.setFees(value);
      break;
    case 27:
      var value = /** @type {string} */ (reader.readString());
      msg.setNetAmt(value);
      break;
    case 28:
      var value = /** @type {string} */ (reader.readString());
      msg.setDescription(value);
      break;
    case 29:
      var value = /** @type {string} */ (reader.readString());
      msg.setBatchNo(value);
      break;
    case 30:
      var value = /** @type {string} */ (reader.readString());
      msg.setStatus(value);
      break;
    case 31:
      var value = /** @type {string} */ (reader.readString());
      msg.setCreatedBy(value);
      break;
    case 32:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setTrnsId(value);
      break;
    case 33:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setAccountId(value);
      break;
    case 34:
      var value = /** @type {string} */ (reader.readString());
      msg.setExecutingVenue(value);
      break;
    case 35:
      var value = /** @type {string} */ (reader.readString());
      msg.setExternalId(value);
      break;
    case 36:
      var value = /** @type {string} */ (reader.readString());
      msg.setOrderId(value);
      break;
    case 37:
      var value = /** @type {string} */ (reader.readString());
      msg.setVendor(value);
      break;
    case 38:
      var value = /** @type {string} */ (reader.readString());
      msg.setContraAccountNo(value);
      break;
    case 39:
      var value = /** @type {string} */ (reader.readString());
      msg.setCommission(value);
      break;
    case 40:
      var value = /** @type {string} */ (reader.readString());
      msg.setContraCorrespondent(value);
      break;
    case 41:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setContraAccountId(value);
      break;
    case 42:
      var value = /** @type {string} */ (reader.readString());
      msg.setOriginalCusip(value);
      break;
    case 43:
      var value = /** @type {string} */ (reader.readString());
      msg.setEntryTypeDescription(value);
      break;
    case 44:
      var value = /** @type {string} */ (reader.readString());
      msg.setRep(value);
      break;
    case 45:
      var value = /** @type {string} */ (reader.readString());
      msg.setBranch(value);
      break;
    case 46:
      var value = /** @type {string} */ (reader.readString());
      msg.setCompressType(value);
      break;
    case 47:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setCompressCount(value);
      break;
    case 48:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setCompressId(value);
      break;
    case 49:
      var value = /** @type {string} */ (reader.readString());
      msg.setTraderId(value);
      break;
    case 50:
      var value = /** @type {string} */ (reader.readString());
      msg.setReferenceId(value);
      break;
    case 51:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setPreviousTrnsId(value);
      break;
    case 52:
      var value = /** @type {string} */ (reader.readString());
      msg.setProduct(value);
      break;
    case 53:
      var value = /** @type {string} */ (reader.readString());
      msg.setAccrual(value);
      break;
    case 54:
      var value = /** @type {string} */ (reader.readString());
      msg.setCouponRate(value);
      break;
    case 55:
      var value = /** @type {string} */ (reader.readString());
      msg.setInterestPayment(value);
      break;
    case 56:
      var value = /** @type {string} */ (reader.readString());
      msg.setYield(value);
      break;
    case 57:
      var value = /** @type {string} */ (reader.readString());
      msg.setOrgType(value);
      break;
    case 58:
      var value = new google_type_date_pb.Date;
      reader.readMessage(value,google_type_date_pb.Date.deserializeBinaryFromReader);
      msg.setOrgTerm(value);
      break;
    case 59:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setSameDayCancel(value);
      break;
    case 60:
      var value = /** @type {string} */ (reader.readString());
      msg.setContraBroker(value);
      break;
    case 61:
      var value = /** @type {string} */ (reader.readString());
      msg.setTaxWithholding(value);
      break;
    case 62:
      var value = /** @type {string} */ (reader.readString());
      msg.setMultiplier(value);
      break;
    case 63:
      var value = /** @type {string} */ (reader.readString());
      msg.setContraSubAccountNo(value);
      break;
    case 64:
      var value = /** @type {string} */ (reader.readString());
      msg.setSubAccountNo(value);
      break;
    case 65:
      var value = /** @type {string} */ (reader.readString());
      msg.setOtherFees(value);
      break;
    case 66:
      var value = /** @type {string} */ (reader.readString());
      msg.setYear(value);
      break;
    case 67:
      var value = /** @type {string} */ (reader.readString());
      msg.setParticipantNo(value);
      break;
    case 68:
      var value = new google_type_date_pb.Date;
      reader.readMessage(value,google_type_date_pb.Date.deserializeBinaryFromReader);
      msg.setAsOfDate(value);
      break;
    case 69:
      var value = /** @type {string} */ (reader.readString());
      msg.setRegisteredAdvisorCapacity(value);
      break;
    case 70:
      var value = /** @type {string} */ (reader.readString());
      msg.setSpecialRemarks(value);
      break;
    case 71:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setTimeOfExecution(value);
      break;
    case 72:
      var value = /** @type {string} */ (reader.readString());
      msg.setPrincipal(value);
      break;
    case 73:
      var value = /** @type {string} */ (reader.readString());
      msg.setMiscFee(value);
      break;
    case 74:
      var value = /** @type {string} */ (reader.readString());
      msg.setOtherFees2(value);
      break;
    case 75:
      var value = /** @type {string} */ (reader.readString());
      msg.setLocation(value);
      break;
    case 76:
      var value = /** @type {string} */ (reader.readString());
      msg.setDiscretion(value);
      break;
    case 77:
      var value = /** @type {string} */ (reader.readString());
      msg.setCurrency(value);
      break;
    case 78:
      var value = /** @type {string} */ (reader.readString());
      msg.setCurrencyRate(value);
      break;
    case 79:
      var value = /** @type {string} */ (reader.readString());
      msg.setCurrencyAmt(value);
      break;
    case 80:
      var value = /** @type {string} */ (reader.readString());
      msg.setExecId(value);
      break;
    case 81:
      var value = /** @type {string} */ (reader.readString());
      msg.setLegId(value);
      break;
    case 82:
      var value = /** @type {string} */ (reader.readString());
      msg.setSettlementMethod(value);
      break;
    case 83:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIsSolicited(value);
      break;
    case 84:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setStepIndicator(value);
      break;
    case 85:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setComparisonIndicator(value);
      break;
    case 86:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setNoRemuneration(value);
      break;
    case 87:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setWhenIssue(value);
      break;
    case 88:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setNewIssue(value);
      break;
    case 89:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIsMsrb(value);
      break;
    case 90:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIsCorp(value);
      break;
    case 91:
      var value = /** @type {string} */ (reader.readString());
      msg.setYtc(value);
      break;
    case 92:
      var value = /** @type {string} */ (reader.readString());
      msg.setYtm(value);
      break;
    case 93:
      var value = /** @type {string} */ (reader.readString());
      msg.setMarkAmount(value);
      break;
    case 94:
      var value = /** @type {string} */ (reader.readString());
      msg.setPmp(value);
      break;
    case 95:
      var value = /** @type {string} */ (reader.readString());
      msg.setMarkRate(value);
      break;
    case 96:
      var value = /** @type {string} */ (reader.readString());
      msg.setAtsIdentifier(value);
      break;
    case 97:
      var value = /** @type {string} */ (reader.readString());
      msg.setCurrencyGrossAmt(value);
      break;
    case 98:
      var value = /** @type {string} */ (reader.readString());
      msg.setCurrencyFees(value);
      break;
    case 100:
      var value = /** @type {string} */ (reader.readString());
      msg.addOtherFeeValues(value);
      break;
    case 101:
      var value = /** @type {string} */ (reader.readString());
      msg.setEuroclearId(value);
      break;
    case 102:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setSettlementInstructionId(value);
      break;
    case 103:
      var value = /** @type {string} */ (reader.readString());
      msg.setOrderType(value);
      break;
    case 104:
      var value = /** @type {string} */ (reader.readString());
      msg.setAccountType(value);
      break;
    case 105:
      var value = /** @type {string} */ (reader.readString());
      msg.setContraBrokerNo(value);
      break;
    case 106:
      var value = /** @type {string} */ (reader.readString());
      msg.setMarginType(value);
      break;
    case 107:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setSubAccountType(value);
      break;
    case 108:
      var value = /** @type {string} */ (reader.readString());
      msg.setOtherFeesList(value);
      break;
    case 109:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setDvpConfirmNo(value);
      break;
    case 110:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIsOpenItem(value);
      break;
    case 111:
      var value = /** @type {string} */ (reader.readString());
      msg.setDvpExternalId(value);
      break;
    case 112:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIsArchived(value);
      break;
    case 113:
      var value = /** @type {string} */ (reader.readString());
      msg.setInternalNote(value);
      break;
    case 114:
      var value = new google_type_date_pb.Date;
      reader.readMessage(value,google_type_date_pb.Date.deserializeBinaryFromReader);
      msg.setEffAtlTradeDate(value);
      break;
    case 115:
      var value = new google_type_date_pb.Date;
      reader.readMessage(value,google_type_date_pb.Date.deserializeBinaryFromReader);
      msg.setEffAtlSettleDate(value);
      break;
    case 116:
      var value = /** @type {string} */ (reader.readString());
      msg.setSource(value);
      break;
    case 117:
      var value = /** @type {string} */ (reader.readString());
      msg.setExecutionQty(value);
      break;
    case 118:
      var value = /** @type {string} */ (reader.readString());
      msg.setExecutionNetAmt(value);
      break;
    case 119:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setReportActivityId(value);
      break;
    case 120:
      var value = /** @type {string} */ (reader.readString());
      msg.setCtmPartyValue(value);
      break;
    case 121:
      var value = /** @type {string} */ (reader.readString());
      msg.setMasterReference(value);
      break;
    case 122:
      var value = /** @type {string} */ (reader.readString());
      msg.setRepoRate(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.reportpb.Activity.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.reportpb.Activity.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.reportpb.Activity} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.reportpb.Activity.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCorrespondent();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getAccountNo();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getAccountName();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getMasterAccountNo();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getEffSettleDate();
  if (f != null) {
    writer.writeMessage(
      5,
      f,
      google_type_date_pb.Date.serializeBinaryToWriter
    );
  }
  f = message.getBroker();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getType();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
  f = message.getCapacity();
  if (f.length > 0) {
    writer.writeString(
      8,
      f
    );
  }
  f = message.getEffTradeDate();
  if (f != null) {
    writer.writeMessage(
      9,
      f,
      google_type_date_pb.Date.serializeBinaryToWriter
    );
  }
  f = message.getSymbol();
  if (f.length > 0) {
    writer.writeString(
      10,
      f
    );
  }
  f = message.getSymbolDescription();
  if (f.length > 0) {
    writer.writeString(
      11,
      f
    );
  }
  f = message.getCusip();
  if (f.length > 0) {
    writer.writeString(
      12,
      f
    );
  }
  f = message.getAssetType();
  if (f.length > 0) {
    writer.writeString(
      13,
      f
    );
  }
  f = message.getCreatedAt();
  if (f != null) {
    writer.writeMessage(
      14,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getSystemDate();
  if (f != null) {
    writer.writeMessage(
      15,
      f,
      google_type_date_pb.Date.serializeBinaryToWriter
    );
  }
  f = message.getTradeDate();
  if (f != null) {
    writer.writeMessage(
      16,
      f,
      google_type_date_pb.Date.serializeBinaryToWriter
    );
  }
  f = message.getTradeAt();
  if (f != null) {
    writer.writeMessage(
      17,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getSettleDate();
  if (f != null) {
    writer.writeMessage(
      18,
      f,
      google_type_date_pb.Date.serializeBinaryToWriter
    );
  }
  f = message.getEntryType();
  if (f.length > 0) {
    writer.writeString(
      19,
      f
    );
  }
  f = message.getSide();
  if (f.length > 0) {
    writer.writeString(
      20,
      f
    );
  }
  f = message.getQty();
  if (f.length > 0) {
    writer.writeString(
      21,
      f
    );
  }
  f = message.getPrice();
  if (f.length > 0) {
    writer.writeString(
      22,
      f
    );
  }
  f = message.getGrossAmt();
  if (f.length > 0) {
    writer.writeString(
      23,
      f
    );
  }
  f = message.getRegFee();
  if (f.length > 0) {
    writer.writeString(
      24,
      f
    );
  }
  f = message.getTafFee();
  if (f.length > 0) {
    writer.writeString(
      25,
      f
    );
  }
  f = message.getFees();
  if (f.length > 0) {
    writer.writeString(
      26,
      f
    );
  }
  f = message.getNetAmt();
  if (f.length > 0) {
    writer.writeString(
      27,
      f
    );
  }
  f = message.getDescription();
  if (f.length > 0) {
    writer.writeString(
      28,
      f
    );
  }
  f = message.getBatchNo();
  if (f.length > 0) {
    writer.writeString(
      29,
      f
    );
  }
  f = message.getStatus();
  if (f.length > 0) {
    writer.writeString(
      30,
      f
    );
  }
  f = message.getCreatedBy();
  if (f.length > 0) {
    writer.writeString(
      31,
      f
    );
  }
  f = message.getTrnsId();
  if (f !== 0) {
    writer.writeUint32(
      32,
      f
    );
  }
  f = message.getAccountId();
  if (f !== 0) {
    writer.writeUint32(
      33,
      f
    );
  }
  f = message.getExecutingVenue();
  if (f.length > 0) {
    writer.writeString(
      34,
      f
    );
  }
  f = message.getExternalId();
  if (f.length > 0) {
    writer.writeString(
      35,
      f
    );
  }
  f = message.getOrderId();
  if (f.length > 0) {
    writer.writeString(
      36,
      f
    );
  }
  f = message.getVendor();
  if (f.length > 0) {
    writer.writeString(
      37,
      f
    );
  }
  f = message.getContraAccountNo();
  if (f.length > 0) {
    writer.writeString(
      38,
      f
    );
  }
  f = message.getCommission();
  if (f.length > 0) {
    writer.writeString(
      39,
      f
    );
  }
  f = message.getContraCorrespondent();
  if (f.length > 0) {
    writer.writeString(
      40,
      f
    );
  }
  f = message.getContraAccountId();
  if (f !== 0) {
    writer.writeUint32(
      41,
      f
    );
  }
  f = message.getOriginalCusip();
  if (f.length > 0) {
    writer.writeString(
      42,
      f
    );
  }
  f = message.getEntryTypeDescription();
  if (f.length > 0) {
    writer.writeString(
      43,
      f
    );
  }
  f = message.getRep();
  if (f.length > 0) {
    writer.writeString(
      44,
      f
    );
  }
  f = message.getBranch();
  if (f.length > 0) {
    writer.writeString(
      45,
      f
    );
  }
  f = message.getCompressType();
  if (f.length > 0) {
    writer.writeString(
      46,
      f
    );
  }
  f = message.getCompressCount();
  if (f !== 0) {
    writer.writeUint32(
      47,
      f
    );
  }
  f = message.getCompressId();
  if (f !== 0) {
    writer.writeUint32(
      48,
      f
    );
  }
  f = message.getTraderId();
  if (f.length > 0) {
    writer.writeString(
      49,
      f
    );
  }
  f = message.getReferenceId();
  if (f.length > 0) {
    writer.writeString(
      50,
      f
    );
  }
  f = message.getPreviousTrnsId();
  if (f !== 0) {
    writer.writeUint32(
      51,
      f
    );
  }
  f = message.getProduct();
  if (f.length > 0) {
    writer.writeString(
      52,
      f
    );
  }
  f = message.getAccrual();
  if (f.length > 0) {
    writer.writeString(
      53,
      f
    );
  }
  f = message.getCouponRate();
  if (f.length > 0) {
    writer.writeString(
      54,
      f
    );
  }
  f = message.getInterestPayment();
  if (f.length > 0) {
    writer.writeString(
      55,
      f
    );
  }
  f = message.getYield();
  if (f.length > 0) {
    writer.writeString(
      56,
      f
    );
  }
  f = message.getOrgType();
  if (f.length > 0) {
    writer.writeString(
      57,
      f
    );
  }
  f = message.getOrgTerm();
  if (f != null) {
    writer.writeMessage(
      58,
      f,
      google_type_date_pb.Date.serializeBinaryToWriter
    );
  }
  f = message.getSameDayCancel();
  if (f) {
    writer.writeBool(
      59,
      f
    );
  }
  f = message.getContraBroker();
  if (f.length > 0) {
    writer.writeString(
      60,
      f
    );
  }
  f = message.getTaxWithholding();
  if (f.length > 0) {
    writer.writeString(
      61,
      f
    );
  }
  f = message.getMultiplier();
  if (f.length > 0) {
    writer.writeString(
      62,
      f
    );
  }
  f = message.getContraSubAccountNo();
  if (f.length > 0) {
    writer.writeString(
      63,
      f
    );
  }
  f = message.getSubAccountNo();
  if (f.length > 0) {
    writer.writeString(
      64,
      f
    );
  }
  f = message.getOtherFees();
  if (f.length > 0) {
    writer.writeString(
      65,
      f
    );
  }
  f = message.getYear();
  if (f.length > 0) {
    writer.writeString(
      66,
      f
    );
  }
  f = message.getParticipantNo();
  if (f.length > 0) {
    writer.writeString(
      67,
      f
    );
  }
  f = message.getAsOfDate();
  if (f != null) {
    writer.writeMessage(
      68,
      f,
      google_type_date_pb.Date.serializeBinaryToWriter
    );
  }
  f = message.getRegisteredAdvisorCapacity();
  if (f.length > 0) {
    writer.writeString(
      69,
      f
    );
  }
  f = message.getSpecialRemarks();
  if (f.length > 0) {
    writer.writeString(
      70,
      f
    );
  }
  f = message.getTimeOfExecution();
  if (f != null) {
    writer.writeMessage(
      71,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getPrincipal();
  if (f.length > 0) {
    writer.writeString(
      72,
      f
    );
  }
  f = message.getMiscFee();
  if (f.length > 0) {
    writer.writeString(
      73,
      f
    );
  }
  f = message.getOtherFees2();
  if (f.length > 0) {
    writer.writeString(
      74,
      f
    );
  }
  f = message.getLocation();
  if (f.length > 0) {
    writer.writeString(
      75,
      f
    );
  }
  f = message.getDiscretion();
  if (f.length > 0) {
    writer.writeString(
      76,
      f
    );
  }
  f = message.getCurrency();
  if (f.length > 0) {
    writer.writeString(
      77,
      f
    );
  }
  f = message.getCurrencyRate();
  if (f.length > 0) {
    writer.writeString(
      78,
      f
    );
  }
  f = message.getCurrencyAmt();
  if (f.length > 0) {
    writer.writeString(
      79,
      f
    );
  }
  f = message.getExecId();
  if (f.length > 0) {
    writer.writeString(
      80,
      f
    );
  }
  f = message.getLegId();
  if (f.length > 0) {
    writer.writeString(
      81,
      f
    );
  }
  f = message.getSettlementMethod();
  if (f.length > 0) {
    writer.writeString(
      82,
      f
    );
  }
  f = message.getIsSolicited();
  if (f) {
    writer.writeBool(
      83,
      f
    );
  }
  f = message.getStepIndicator();
  if (f) {
    writer.writeBool(
      84,
      f
    );
  }
  f = message.getComparisonIndicator();
  if (f) {
    writer.writeBool(
      85,
      f
    );
  }
  f = message.getNoRemuneration();
  if (f) {
    writer.writeBool(
      86,
      f
    );
  }
  f = message.getWhenIssue();
  if (f) {
    writer.writeBool(
      87,
      f
    );
  }
  f = message.getNewIssue();
  if (f) {
    writer.writeBool(
      88,
      f
    );
  }
  f = message.getIsMsrb();
  if (f) {
    writer.writeBool(
      89,
      f
    );
  }
  f = message.getIsCorp();
  if (f) {
    writer.writeBool(
      90,
      f
    );
  }
  f = message.getYtc();
  if (f.length > 0) {
    writer.writeString(
      91,
      f
    );
  }
  f = message.getYtm();
  if (f.length > 0) {
    writer.writeString(
      92,
      f
    );
  }
  f = message.getMarkAmount();
  if (f.length > 0) {
    writer.writeString(
      93,
      f
    );
  }
  f = message.getPmp();
  if (f.length > 0) {
    writer.writeString(
      94,
      f
    );
  }
  f = message.getMarkRate();
  if (f.length > 0) {
    writer.writeString(
      95,
      f
    );
  }
  f = message.getAtsIdentifier();
  if (f.length > 0) {
    writer.writeString(
      96,
      f
    );
  }
  f = message.getCurrencyGrossAmt();
  if (f.length > 0) {
    writer.writeString(
      97,
      f
    );
  }
  f = message.getCurrencyFees();
  if (f.length > 0) {
    writer.writeString(
      98,
      f
    );
  }
  f = message.getOtherFeeValuesList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      100,
      f
    );
  }
  f = message.getEuroclearId();
  if (f.length > 0) {
    writer.writeString(
      101,
      f
    );
  }
  f = message.getSettlementInstructionId();
  if (f !== 0) {
    writer.writeUint32(
      102,
      f
    );
  }
  f = message.getOrderType();
  if (f.length > 0) {
    writer.writeString(
      103,
      f
    );
  }
  f = message.getAccountType();
  if (f.length > 0) {
    writer.writeString(
      104,
      f
    );
  }
  f = message.getContraBrokerNo();
  if (f.length > 0) {
    writer.writeString(
      105,
      f
    );
  }
  f = message.getMarginType();
  if (f.length > 0) {
    writer.writeString(
      106,
      f
    );
  }
  f = message.getSubAccountType();
  if (f !== 0) {
    writer.writeUint32(
      107,
      f
    );
  }
  f = message.getOtherFeesList();
  if (f.length > 0) {
    writer.writeString(
      108,
      f
    );
  }
  f = message.getDvpConfirmNo();
  if (f !== 0) {
    writer.writeUint32(
      109,
      f
    );
  }
  f = message.getIsOpenItem();
  if (f) {
    writer.writeBool(
      110,
      f
    );
  }
  f = message.getDvpExternalId();
  if (f.length > 0) {
    writer.writeString(
      111,
      f
    );
  }
  f = message.getIsArchived();
  if (f) {
    writer.writeBool(
      112,
      f
    );
  }
  f = message.getInternalNote();
  if (f.length > 0) {
    writer.writeString(
      113,
      f
    );
  }
  f = message.getEffAtlTradeDate();
  if (f != null) {
    writer.writeMessage(
      114,
      f,
      google_type_date_pb.Date.serializeBinaryToWriter
    );
  }
  f = message.getEffAtlSettleDate();
  if (f != null) {
    writer.writeMessage(
      115,
      f,
      google_type_date_pb.Date.serializeBinaryToWriter
    );
  }
  f = message.getSource();
  if (f.length > 0) {
    writer.writeString(
      116,
      f
    );
  }
  f = message.getExecutionQty();
  if (f.length > 0) {
    writer.writeString(
      117,
      f
    );
  }
  f = message.getExecutionNetAmt();
  if (f.length > 0) {
    writer.writeString(
      118,
      f
    );
  }
  f = message.getReportActivityId();
  if (f !== 0) {
    writer.writeUint32(
      119,
      f
    );
  }
  f = message.getCtmPartyValue();
  if (f.length > 0) {
    writer.writeString(
      120,
      f
    );
  }
  f = message.getMasterReference();
  if (f.length > 0) {
    writer.writeString(
      121,
      f
    );
  }
  f = message.getRepoRate();
  if (f.length > 0) {
    writer.writeString(
      122,
      f
    );
  }
};


/**
 * optional string correspondent = 1;
 * @return {string}
 */
proto.reportpb.Activity.prototype.getCorrespondent = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.reportpb.Activity} returns this
 */
proto.reportpb.Activity.prototype.setCorrespondent = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string account_no = 2;
 * @return {string}
 */
proto.reportpb.Activity.prototype.getAccountNo = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.reportpb.Activity} returns this
 */
proto.reportpb.Activity.prototype.setAccountNo = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string account_name = 3;
 * @return {string}
 */
proto.reportpb.Activity.prototype.getAccountName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.reportpb.Activity} returns this
 */
proto.reportpb.Activity.prototype.setAccountName = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string master_account_no = 4;
 * @return {string}
 */
proto.reportpb.Activity.prototype.getMasterAccountNo = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.reportpb.Activity} returns this
 */
proto.reportpb.Activity.prototype.setMasterAccountNo = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional google.type.Date eff_settle_date = 5;
 * @return {?proto.google.type.Date}
 */
proto.reportpb.Activity.prototype.getEffSettleDate = function() {
  return /** @type{?proto.google.type.Date} */ (
    jspb.Message.getWrapperField(this, google_type_date_pb.Date, 5));
};


/**
 * @param {?proto.google.type.Date|undefined} value
 * @return {!proto.reportpb.Activity} returns this
*/
proto.reportpb.Activity.prototype.setEffSettleDate = function(value) {
  return jspb.Message.setWrapperField(this, 5, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.reportpb.Activity} returns this
 */
proto.reportpb.Activity.prototype.clearEffSettleDate = function() {
  return this.setEffSettleDate(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.reportpb.Activity.prototype.hasEffSettleDate = function() {
  return jspb.Message.getField(this, 5) != null;
};


/**
 * optional string broker = 6;
 * @return {string}
 */
proto.reportpb.Activity.prototype.getBroker = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.reportpb.Activity} returns this
 */
proto.reportpb.Activity.prototype.setBroker = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * optional string type = 7;
 * @return {string}
 */
proto.reportpb.Activity.prototype.getType = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/**
 * @param {string} value
 * @return {!proto.reportpb.Activity} returns this
 */
proto.reportpb.Activity.prototype.setType = function(value) {
  return jspb.Message.setProto3StringField(this, 7, value);
};


/**
 * optional string capacity = 8;
 * @return {string}
 */
proto.reportpb.Activity.prototype.getCapacity = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 8, ""));
};


/**
 * @param {string} value
 * @return {!proto.reportpb.Activity} returns this
 */
proto.reportpb.Activity.prototype.setCapacity = function(value) {
  return jspb.Message.setProto3StringField(this, 8, value);
};


/**
 * optional google.type.Date eff_trade_date = 9;
 * @return {?proto.google.type.Date}
 */
proto.reportpb.Activity.prototype.getEffTradeDate = function() {
  return /** @type{?proto.google.type.Date} */ (
    jspb.Message.getWrapperField(this, google_type_date_pb.Date, 9));
};


/**
 * @param {?proto.google.type.Date|undefined} value
 * @return {!proto.reportpb.Activity} returns this
*/
proto.reportpb.Activity.prototype.setEffTradeDate = function(value) {
  return jspb.Message.setWrapperField(this, 9, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.reportpb.Activity} returns this
 */
proto.reportpb.Activity.prototype.clearEffTradeDate = function() {
  return this.setEffTradeDate(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.reportpb.Activity.prototype.hasEffTradeDate = function() {
  return jspb.Message.getField(this, 9) != null;
};


/**
 * optional string symbol = 10;
 * @return {string}
 */
proto.reportpb.Activity.prototype.getSymbol = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 10, ""));
};


/**
 * @param {string} value
 * @return {!proto.reportpb.Activity} returns this
 */
proto.reportpb.Activity.prototype.setSymbol = function(value) {
  return jspb.Message.setProto3StringField(this, 10, value);
};


/**
 * optional string symbol_description = 11;
 * @return {string}
 */
proto.reportpb.Activity.prototype.getSymbolDescription = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 11, ""));
};


/**
 * @param {string} value
 * @return {!proto.reportpb.Activity} returns this
 */
proto.reportpb.Activity.prototype.setSymbolDescription = function(value) {
  return jspb.Message.setProto3StringField(this, 11, value);
};


/**
 * optional string cusip = 12;
 * @return {string}
 */
proto.reportpb.Activity.prototype.getCusip = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 12, ""));
};


/**
 * @param {string} value
 * @return {!proto.reportpb.Activity} returns this
 */
proto.reportpb.Activity.prototype.setCusip = function(value) {
  return jspb.Message.setProto3StringField(this, 12, value);
};


/**
 * optional string asset_type = 13;
 * @return {string}
 */
proto.reportpb.Activity.prototype.getAssetType = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 13, ""));
};


/**
 * @param {string} value
 * @return {!proto.reportpb.Activity} returns this
 */
proto.reportpb.Activity.prototype.setAssetType = function(value) {
  return jspb.Message.setProto3StringField(this, 13, value);
};


/**
 * optional google.protobuf.Timestamp created_at = 14;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.reportpb.Activity.prototype.getCreatedAt = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 14));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.reportpb.Activity} returns this
*/
proto.reportpb.Activity.prototype.setCreatedAt = function(value) {
  return jspb.Message.setWrapperField(this, 14, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.reportpb.Activity} returns this
 */
proto.reportpb.Activity.prototype.clearCreatedAt = function() {
  return this.setCreatedAt(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.reportpb.Activity.prototype.hasCreatedAt = function() {
  return jspb.Message.getField(this, 14) != null;
};


/**
 * optional google.type.Date system_date = 15;
 * @return {?proto.google.type.Date}
 */
proto.reportpb.Activity.prototype.getSystemDate = function() {
  return /** @type{?proto.google.type.Date} */ (
    jspb.Message.getWrapperField(this, google_type_date_pb.Date, 15));
};


/**
 * @param {?proto.google.type.Date|undefined} value
 * @return {!proto.reportpb.Activity} returns this
*/
proto.reportpb.Activity.prototype.setSystemDate = function(value) {
  return jspb.Message.setWrapperField(this, 15, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.reportpb.Activity} returns this
 */
proto.reportpb.Activity.prototype.clearSystemDate = function() {
  return this.setSystemDate(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.reportpb.Activity.prototype.hasSystemDate = function() {
  return jspb.Message.getField(this, 15) != null;
};


/**
 * optional google.type.Date trade_date = 16;
 * @return {?proto.google.type.Date}
 */
proto.reportpb.Activity.prototype.getTradeDate = function() {
  return /** @type{?proto.google.type.Date} */ (
    jspb.Message.getWrapperField(this, google_type_date_pb.Date, 16));
};


/**
 * @param {?proto.google.type.Date|undefined} value
 * @return {!proto.reportpb.Activity} returns this
*/
proto.reportpb.Activity.prototype.setTradeDate = function(value) {
  return jspb.Message.setWrapperField(this, 16, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.reportpb.Activity} returns this
 */
proto.reportpb.Activity.prototype.clearTradeDate = function() {
  return this.setTradeDate(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.reportpb.Activity.prototype.hasTradeDate = function() {
  return jspb.Message.getField(this, 16) != null;
};


/**
 * optional google.protobuf.Timestamp trade_at = 17;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.reportpb.Activity.prototype.getTradeAt = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 17));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.reportpb.Activity} returns this
*/
proto.reportpb.Activity.prototype.setTradeAt = function(value) {
  return jspb.Message.setWrapperField(this, 17, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.reportpb.Activity} returns this
 */
proto.reportpb.Activity.prototype.clearTradeAt = function() {
  return this.setTradeAt(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.reportpb.Activity.prototype.hasTradeAt = function() {
  return jspb.Message.getField(this, 17) != null;
};


/**
 * optional google.type.Date settle_date = 18;
 * @return {?proto.google.type.Date}
 */
proto.reportpb.Activity.prototype.getSettleDate = function() {
  return /** @type{?proto.google.type.Date} */ (
    jspb.Message.getWrapperField(this, google_type_date_pb.Date, 18));
};


/**
 * @param {?proto.google.type.Date|undefined} value
 * @return {!proto.reportpb.Activity} returns this
*/
proto.reportpb.Activity.prototype.setSettleDate = function(value) {
  return jspb.Message.setWrapperField(this, 18, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.reportpb.Activity} returns this
 */
proto.reportpb.Activity.prototype.clearSettleDate = function() {
  return this.setSettleDate(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.reportpb.Activity.prototype.hasSettleDate = function() {
  return jspb.Message.getField(this, 18) != null;
};


/**
 * optional string entry_type = 19;
 * @return {string}
 */
proto.reportpb.Activity.prototype.getEntryType = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 19, ""));
};


/**
 * @param {string} value
 * @return {!proto.reportpb.Activity} returns this
 */
proto.reportpb.Activity.prototype.setEntryType = function(value) {
  return jspb.Message.setProto3StringField(this, 19, value);
};


/**
 * optional string side = 20;
 * @return {string}
 */
proto.reportpb.Activity.prototype.getSide = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 20, ""));
};


/**
 * @param {string} value
 * @return {!proto.reportpb.Activity} returns this
 */
proto.reportpb.Activity.prototype.setSide = function(value) {
  return jspb.Message.setProto3StringField(this, 20, value);
};


/**
 * optional string qty = 21;
 * @return {string}
 */
proto.reportpb.Activity.prototype.getQty = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 21, ""));
};


/**
 * @param {string} value
 * @return {!proto.reportpb.Activity} returns this
 */
proto.reportpb.Activity.prototype.setQty = function(value) {
  return jspb.Message.setProto3StringField(this, 21, value);
};


/**
 * optional string price = 22;
 * @return {string}
 */
proto.reportpb.Activity.prototype.getPrice = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 22, ""));
};


/**
 * @param {string} value
 * @return {!proto.reportpb.Activity} returns this
 */
proto.reportpb.Activity.prototype.setPrice = function(value) {
  return jspb.Message.setProto3StringField(this, 22, value);
};


/**
 * optional string gross_amt = 23;
 * @return {string}
 */
proto.reportpb.Activity.prototype.getGrossAmt = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 23, ""));
};


/**
 * @param {string} value
 * @return {!proto.reportpb.Activity} returns this
 */
proto.reportpb.Activity.prototype.setGrossAmt = function(value) {
  return jspb.Message.setProto3StringField(this, 23, value);
};


/**
 * optional string reg_fee = 24;
 * @return {string}
 */
proto.reportpb.Activity.prototype.getRegFee = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 24, ""));
};


/**
 * @param {string} value
 * @return {!proto.reportpb.Activity} returns this
 */
proto.reportpb.Activity.prototype.setRegFee = function(value) {
  return jspb.Message.setProto3StringField(this, 24, value);
};


/**
 * optional string taf_fee = 25;
 * @return {string}
 */
proto.reportpb.Activity.prototype.getTafFee = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 25, ""));
};


/**
 * @param {string} value
 * @return {!proto.reportpb.Activity} returns this
 */
proto.reportpb.Activity.prototype.setTafFee = function(value) {
  return jspb.Message.setProto3StringField(this, 25, value);
};


/**
 * optional string fees = 26;
 * @return {string}
 */
proto.reportpb.Activity.prototype.getFees = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 26, ""));
};


/**
 * @param {string} value
 * @return {!proto.reportpb.Activity} returns this
 */
proto.reportpb.Activity.prototype.setFees = function(value) {
  return jspb.Message.setProto3StringField(this, 26, value);
};


/**
 * optional string net_amt = 27;
 * @return {string}
 */
proto.reportpb.Activity.prototype.getNetAmt = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 27, ""));
};


/**
 * @param {string} value
 * @return {!proto.reportpb.Activity} returns this
 */
proto.reportpb.Activity.prototype.setNetAmt = function(value) {
  return jspb.Message.setProto3StringField(this, 27, value);
};


/**
 * optional string description = 28;
 * @return {string}
 */
proto.reportpb.Activity.prototype.getDescription = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 28, ""));
};


/**
 * @param {string} value
 * @return {!proto.reportpb.Activity} returns this
 */
proto.reportpb.Activity.prototype.setDescription = function(value) {
  return jspb.Message.setProto3StringField(this, 28, value);
};


/**
 * optional string batch_no = 29;
 * @return {string}
 */
proto.reportpb.Activity.prototype.getBatchNo = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 29, ""));
};


/**
 * @param {string} value
 * @return {!proto.reportpb.Activity} returns this
 */
proto.reportpb.Activity.prototype.setBatchNo = function(value) {
  return jspb.Message.setProto3StringField(this, 29, value);
};


/**
 * optional string status = 30;
 * @return {string}
 */
proto.reportpb.Activity.prototype.getStatus = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 30, ""));
};


/**
 * @param {string} value
 * @return {!proto.reportpb.Activity} returns this
 */
proto.reportpb.Activity.prototype.setStatus = function(value) {
  return jspb.Message.setProto3StringField(this, 30, value);
};


/**
 * optional string created_by = 31;
 * @return {string}
 */
proto.reportpb.Activity.prototype.getCreatedBy = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 31, ""));
};


/**
 * @param {string} value
 * @return {!proto.reportpb.Activity} returns this
 */
proto.reportpb.Activity.prototype.setCreatedBy = function(value) {
  return jspb.Message.setProto3StringField(this, 31, value);
};


/**
 * optional uint32 trns_id = 32;
 * @return {number}
 */
proto.reportpb.Activity.prototype.getTrnsId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 32, 0));
};


/**
 * @param {number} value
 * @return {!proto.reportpb.Activity} returns this
 */
proto.reportpb.Activity.prototype.setTrnsId = function(value) {
  return jspb.Message.setProto3IntField(this, 32, value);
};


/**
 * optional uint32 account_id = 33;
 * @return {number}
 */
proto.reportpb.Activity.prototype.getAccountId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 33, 0));
};


/**
 * @param {number} value
 * @return {!proto.reportpb.Activity} returns this
 */
proto.reportpb.Activity.prototype.setAccountId = function(value) {
  return jspb.Message.setProto3IntField(this, 33, value);
};


/**
 * optional string executing_venue = 34;
 * @return {string}
 */
proto.reportpb.Activity.prototype.getExecutingVenue = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 34, ""));
};


/**
 * @param {string} value
 * @return {!proto.reportpb.Activity} returns this
 */
proto.reportpb.Activity.prototype.setExecutingVenue = function(value) {
  return jspb.Message.setProto3StringField(this, 34, value);
};


/**
 * optional string external_id = 35;
 * @return {string}
 */
proto.reportpb.Activity.prototype.getExternalId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 35, ""));
};


/**
 * @param {string} value
 * @return {!proto.reportpb.Activity} returns this
 */
proto.reportpb.Activity.prototype.setExternalId = function(value) {
  return jspb.Message.setProto3StringField(this, 35, value);
};


/**
 * optional string order_id = 36;
 * @return {string}
 */
proto.reportpb.Activity.prototype.getOrderId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 36, ""));
};


/**
 * @param {string} value
 * @return {!proto.reportpb.Activity} returns this
 */
proto.reportpb.Activity.prototype.setOrderId = function(value) {
  return jspb.Message.setProto3StringField(this, 36, value);
};


/**
 * optional string vendor = 37;
 * @return {string}
 */
proto.reportpb.Activity.prototype.getVendor = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 37, ""));
};


/**
 * @param {string} value
 * @return {!proto.reportpb.Activity} returns this
 */
proto.reportpb.Activity.prototype.setVendor = function(value) {
  return jspb.Message.setProto3StringField(this, 37, value);
};


/**
 * optional string contra_account_no = 38;
 * @return {string}
 */
proto.reportpb.Activity.prototype.getContraAccountNo = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 38, ""));
};


/**
 * @param {string} value
 * @return {!proto.reportpb.Activity} returns this
 */
proto.reportpb.Activity.prototype.setContraAccountNo = function(value) {
  return jspb.Message.setProto3StringField(this, 38, value);
};


/**
 * optional string commission = 39;
 * @return {string}
 */
proto.reportpb.Activity.prototype.getCommission = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 39, ""));
};


/**
 * @param {string} value
 * @return {!proto.reportpb.Activity} returns this
 */
proto.reportpb.Activity.prototype.setCommission = function(value) {
  return jspb.Message.setProto3StringField(this, 39, value);
};


/**
 * optional string contra_correspondent = 40;
 * @return {string}
 */
proto.reportpb.Activity.prototype.getContraCorrespondent = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 40, ""));
};


/**
 * @param {string} value
 * @return {!proto.reportpb.Activity} returns this
 */
proto.reportpb.Activity.prototype.setContraCorrespondent = function(value) {
  return jspb.Message.setProto3StringField(this, 40, value);
};


/**
 * optional uint32 contra_account_id = 41;
 * @return {number}
 */
proto.reportpb.Activity.prototype.getContraAccountId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 41, 0));
};


/**
 * @param {number} value
 * @return {!proto.reportpb.Activity} returns this
 */
proto.reportpb.Activity.prototype.setContraAccountId = function(value) {
  return jspb.Message.setProto3IntField(this, 41, value);
};


/**
 * optional string original_cusip = 42;
 * @return {string}
 */
proto.reportpb.Activity.prototype.getOriginalCusip = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 42, ""));
};


/**
 * @param {string} value
 * @return {!proto.reportpb.Activity} returns this
 */
proto.reportpb.Activity.prototype.setOriginalCusip = function(value) {
  return jspb.Message.setProto3StringField(this, 42, value);
};


/**
 * optional string entry_type_description = 43;
 * @return {string}
 */
proto.reportpb.Activity.prototype.getEntryTypeDescription = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 43, ""));
};


/**
 * @param {string} value
 * @return {!proto.reportpb.Activity} returns this
 */
proto.reportpb.Activity.prototype.setEntryTypeDescription = function(value) {
  return jspb.Message.setProto3StringField(this, 43, value);
};


/**
 * optional string rep = 44;
 * @return {string}
 */
proto.reportpb.Activity.prototype.getRep = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 44, ""));
};


/**
 * @param {string} value
 * @return {!proto.reportpb.Activity} returns this
 */
proto.reportpb.Activity.prototype.setRep = function(value) {
  return jspb.Message.setProto3StringField(this, 44, value);
};


/**
 * optional string branch = 45;
 * @return {string}
 */
proto.reportpb.Activity.prototype.getBranch = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 45, ""));
};


/**
 * @param {string} value
 * @return {!proto.reportpb.Activity} returns this
 */
proto.reportpb.Activity.prototype.setBranch = function(value) {
  return jspb.Message.setProto3StringField(this, 45, value);
};


/**
 * optional string compress_type = 46;
 * @return {string}
 */
proto.reportpb.Activity.prototype.getCompressType = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 46, ""));
};


/**
 * @param {string} value
 * @return {!proto.reportpb.Activity} returns this
 */
proto.reportpb.Activity.prototype.setCompressType = function(value) {
  return jspb.Message.setProto3StringField(this, 46, value);
};


/**
 * optional uint32 compress_count = 47;
 * @return {number}
 */
proto.reportpb.Activity.prototype.getCompressCount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 47, 0));
};


/**
 * @param {number} value
 * @return {!proto.reportpb.Activity} returns this
 */
proto.reportpb.Activity.prototype.setCompressCount = function(value) {
  return jspb.Message.setProto3IntField(this, 47, value);
};


/**
 * optional uint32 compress_id = 48;
 * @return {number}
 */
proto.reportpb.Activity.prototype.getCompressId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 48, 0));
};


/**
 * @param {number} value
 * @return {!proto.reportpb.Activity} returns this
 */
proto.reportpb.Activity.prototype.setCompressId = function(value) {
  return jspb.Message.setProto3IntField(this, 48, value);
};


/**
 * optional string trader_id = 49;
 * @return {string}
 */
proto.reportpb.Activity.prototype.getTraderId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 49, ""));
};


/**
 * @param {string} value
 * @return {!proto.reportpb.Activity} returns this
 */
proto.reportpb.Activity.prototype.setTraderId = function(value) {
  return jspb.Message.setProto3StringField(this, 49, value);
};


/**
 * optional string reference_id = 50;
 * @return {string}
 */
proto.reportpb.Activity.prototype.getReferenceId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 50, ""));
};


/**
 * @param {string} value
 * @return {!proto.reportpb.Activity} returns this
 */
proto.reportpb.Activity.prototype.setReferenceId = function(value) {
  return jspb.Message.setProto3StringField(this, 50, value);
};


/**
 * optional uint32 previous_trns_id = 51;
 * @return {number}
 */
proto.reportpb.Activity.prototype.getPreviousTrnsId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 51, 0));
};


/**
 * @param {number} value
 * @return {!proto.reportpb.Activity} returns this
 */
proto.reportpb.Activity.prototype.setPreviousTrnsId = function(value) {
  return jspb.Message.setProto3IntField(this, 51, value);
};


/**
 * optional string product = 52;
 * @return {string}
 */
proto.reportpb.Activity.prototype.getProduct = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 52, ""));
};


/**
 * @param {string} value
 * @return {!proto.reportpb.Activity} returns this
 */
proto.reportpb.Activity.prototype.setProduct = function(value) {
  return jspb.Message.setProto3StringField(this, 52, value);
};


/**
 * optional string accrual = 53;
 * @return {string}
 */
proto.reportpb.Activity.prototype.getAccrual = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 53, ""));
};


/**
 * @param {string} value
 * @return {!proto.reportpb.Activity} returns this
 */
proto.reportpb.Activity.prototype.setAccrual = function(value) {
  return jspb.Message.setProto3StringField(this, 53, value);
};


/**
 * optional string coupon_rate = 54;
 * @return {string}
 */
proto.reportpb.Activity.prototype.getCouponRate = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 54, ""));
};


/**
 * @param {string} value
 * @return {!proto.reportpb.Activity} returns this
 */
proto.reportpb.Activity.prototype.setCouponRate = function(value) {
  return jspb.Message.setProto3StringField(this, 54, value);
};


/**
 * optional string interest_payment = 55;
 * @return {string}
 */
proto.reportpb.Activity.prototype.getInterestPayment = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 55, ""));
};


/**
 * @param {string} value
 * @return {!proto.reportpb.Activity} returns this
 */
proto.reportpb.Activity.prototype.setInterestPayment = function(value) {
  return jspb.Message.setProto3StringField(this, 55, value);
};


/**
 * optional string yield = 56;
 * @return {string}
 */
proto.reportpb.Activity.prototype.getYield = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 56, ""));
};


/**
 * @param {string} value
 * @return {!proto.reportpb.Activity} returns this
 */
proto.reportpb.Activity.prototype.setYield = function(value) {
  return jspb.Message.setProto3StringField(this, 56, value);
};


/**
 * optional string org_type = 57;
 * @return {string}
 */
proto.reportpb.Activity.prototype.getOrgType = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 57, ""));
};


/**
 * @param {string} value
 * @return {!proto.reportpb.Activity} returns this
 */
proto.reportpb.Activity.prototype.setOrgType = function(value) {
  return jspb.Message.setProto3StringField(this, 57, value);
};


/**
 * optional google.type.Date org_term = 58;
 * @return {?proto.google.type.Date}
 */
proto.reportpb.Activity.prototype.getOrgTerm = function() {
  return /** @type{?proto.google.type.Date} */ (
    jspb.Message.getWrapperField(this, google_type_date_pb.Date, 58));
};


/**
 * @param {?proto.google.type.Date|undefined} value
 * @return {!proto.reportpb.Activity} returns this
*/
proto.reportpb.Activity.prototype.setOrgTerm = function(value) {
  return jspb.Message.setWrapperField(this, 58, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.reportpb.Activity} returns this
 */
proto.reportpb.Activity.prototype.clearOrgTerm = function() {
  return this.setOrgTerm(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.reportpb.Activity.prototype.hasOrgTerm = function() {
  return jspb.Message.getField(this, 58) != null;
};


/**
 * optional bool same_day_cancel = 59;
 * @return {boolean}
 */
proto.reportpb.Activity.prototype.getSameDayCancel = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 59, false));
};


/**
 * @param {boolean} value
 * @return {!proto.reportpb.Activity} returns this
 */
proto.reportpb.Activity.prototype.setSameDayCancel = function(value) {
  return jspb.Message.setProto3BooleanField(this, 59, value);
};


/**
 * optional string contra_broker = 60;
 * @return {string}
 */
proto.reportpb.Activity.prototype.getContraBroker = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 60, ""));
};


/**
 * @param {string} value
 * @return {!proto.reportpb.Activity} returns this
 */
proto.reportpb.Activity.prototype.setContraBroker = function(value) {
  return jspb.Message.setProto3StringField(this, 60, value);
};


/**
 * optional string tax_withholding = 61;
 * @return {string}
 */
proto.reportpb.Activity.prototype.getTaxWithholding = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 61, ""));
};


/**
 * @param {string} value
 * @return {!proto.reportpb.Activity} returns this
 */
proto.reportpb.Activity.prototype.setTaxWithholding = function(value) {
  return jspb.Message.setProto3StringField(this, 61, value);
};


/**
 * optional string multiplier = 62;
 * @return {string}
 */
proto.reportpb.Activity.prototype.getMultiplier = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 62, ""));
};


/**
 * @param {string} value
 * @return {!proto.reportpb.Activity} returns this
 */
proto.reportpb.Activity.prototype.setMultiplier = function(value) {
  return jspb.Message.setProto3StringField(this, 62, value);
};


/**
 * optional string contra_sub_account_no = 63;
 * @return {string}
 */
proto.reportpb.Activity.prototype.getContraSubAccountNo = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 63, ""));
};


/**
 * @param {string} value
 * @return {!proto.reportpb.Activity} returns this
 */
proto.reportpb.Activity.prototype.setContraSubAccountNo = function(value) {
  return jspb.Message.setProto3StringField(this, 63, value);
};


/**
 * optional string sub_account_no = 64;
 * @return {string}
 */
proto.reportpb.Activity.prototype.getSubAccountNo = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 64, ""));
};


/**
 * @param {string} value
 * @return {!proto.reportpb.Activity} returns this
 */
proto.reportpb.Activity.prototype.setSubAccountNo = function(value) {
  return jspb.Message.setProto3StringField(this, 64, value);
};


/**
 * optional string other_fees = 65;
 * @return {string}
 */
proto.reportpb.Activity.prototype.getOtherFees = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 65, ""));
};


/**
 * @param {string} value
 * @return {!proto.reportpb.Activity} returns this
 */
proto.reportpb.Activity.prototype.setOtherFees = function(value) {
  return jspb.Message.setProto3StringField(this, 65, value);
};


/**
 * optional string year = 66;
 * @return {string}
 */
proto.reportpb.Activity.prototype.getYear = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 66, ""));
};


/**
 * @param {string} value
 * @return {!proto.reportpb.Activity} returns this
 */
proto.reportpb.Activity.prototype.setYear = function(value) {
  return jspb.Message.setProto3StringField(this, 66, value);
};


/**
 * optional string participant_no = 67;
 * @return {string}
 */
proto.reportpb.Activity.prototype.getParticipantNo = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 67, ""));
};


/**
 * @param {string} value
 * @return {!proto.reportpb.Activity} returns this
 */
proto.reportpb.Activity.prototype.setParticipantNo = function(value) {
  return jspb.Message.setProto3StringField(this, 67, value);
};


/**
 * optional google.type.Date as_of_date = 68;
 * @return {?proto.google.type.Date}
 */
proto.reportpb.Activity.prototype.getAsOfDate = function() {
  return /** @type{?proto.google.type.Date} */ (
    jspb.Message.getWrapperField(this, google_type_date_pb.Date, 68));
};


/**
 * @param {?proto.google.type.Date|undefined} value
 * @return {!proto.reportpb.Activity} returns this
*/
proto.reportpb.Activity.prototype.setAsOfDate = function(value) {
  return jspb.Message.setWrapperField(this, 68, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.reportpb.Activity} returns this
 */
proto.reportpb.Activity.prototype.clearAsOfDate = function() {
  return this.setAsOfDate(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.reportpb.Activity.prototype.hasAsOfDate = function() {
  return jspb.Message.getField(this, 68) != null;
};


/**
 * optional string registered_advisor_capacity = 69;
 * @return {string}
 */
proto.reportpb.Activity.prototype.getRegisteredAdvisorCapacity = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 69, ""));
};


/**
 * @param {string} value
 * @return {!proto.reportpb.Activity} returns this
 */
proto.reportpb.Activity.prototype.setRegisteredAdvisorCapacity = function(value) {
  return jspb.Message.setProto3StringField(this, 69, value);
};


/**
 * optional string special_remarks = 70;
 * @return {string}
 */
proto.reportpb.Activity.prototype.getSpecialRemarks = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 70, ""));
};


/**
 * @param {string} value
 * @return {!proto.reportpb.Activity} returns this
 */
proto.reportpb.Activity.prototype.setSpecialRemarks = function(value) {
  return jspb.Message.setProto3StringField(this, 70, value);
};


/**
 * optional google.protobuf.Timestamp time_of_execution = 71;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.reportpb.Activity.prototype.getTimeOfExecution = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 71));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.reportpb.Activity} returns this
*/
proto.reportpb.Activity.prototype.setTimeOfExecution = function(value) {
  return jspb.Message.setWrapperField(this, 71, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.reportpb.Activity} returns this
 */
proto.reportpb.Activity.prototype.clearTimeOfExecution = function() {
  return this.setTimeOfExecution(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.reportpb.Activity.prototype.hasTimeOfExecution = function() {
  return jspb.Message.getField(this, 71) != null;
};


/**
 * optional string principal = 72;
 * @return {string}
 */
proto.reportpb.Activity.prototype.getPrincipal = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 72, ""));
};


/**
 * @param {string} value
 * @return {!proto.reportpb.Activity} returns this
 */
proto.reportpb.Activity.prototype.setPrincipal = function(value) {
  return jspb.Message.setProto3StringField(this, 72, value);
};


/**
 * optional string misc_fee = 73;
 * @return {string}
 */
proto.reportpb.Activity.prototype.getMiscFee = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 73, ""));
};


/**
 * @param {string} value
 * @return {!proto.reportpb.Activity} returns this
 */
proto.reportpb.Activity.prototype.setMiscFee = function(value) {
  return jspb.Message.setProto3StringField(this, 73, value);
};


/**
 * optional string other_fees_2 = 74;
 * @return {string}
 */
proto.reportpb.Activity.prototype.getOtherFees2 = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 74, ""));
};


/**
 * @param {string} value
 * @return {!proto.reportpb.Activity} returns this
 */
proto.reportpb.Activity.prototype.setOtherFees2 = function(value) {
  return jspb.Message.setProto3StringField(this, 74, value);
};


/**
 * optional string location = 75;
 * @return {string}
 */
proto.reportpb.Activity.prototype.getLocation = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 75, ""));
};


/**
 * @param {string} value
 * @return {!proto.reportpb.Activity} returns this
 */
proto.reportpb.Activity.prototype.setLocation = function(value) {
  return jspb.Message.setProto3StringField(this, 75, value);
};


/**
 * optional string discretion = 76;
 * @return {string}
 */
proto.reportpb.Activity.prototype.getDiscretion = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 76, ""));
};


/**
 * @param {string} value
 * @return {!proto.reportpb.Activity} returns this
 */
proto.reportpb.Activity.prototype.setDiscretion = function(value) {
  return jspb.Message.setProto3StringField(this, 76, value);
};


/**
 * optional string currency = 77;
 * @return {string}
 */
proto.reportpb.Activity.prototype.getCurrency = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 77, ""));
};


/**
 * @param {string} value
 * @return {!proto.reportpb.Activity} returns this
 */
proto.reportpb.Activity.prototype.setCurrency = function(value) {
  return jspb.Message.setProto3StringField(this, 77, value);
};


/**
 * optional string currency_rate = 78;
 * @return {string}
 */
proto.reportpb.Activity.prototype.getCurrencyRate = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 78, ""));
};


/**
 * @param {string} value
 * @return {!proto.reportpb.Activity} returns this
 */
proto.reportpb.Activity.prototype.setCurrencyRate = function(value) {
  return jspb.Message.setProto3StringField(this, 78, value);
};


/**
 * optional string currency_amt = 79;
 * @return {string}
 */
proto.reportpb.Activity.prototype.getCurrencyAmt = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 79, ""));
};


/**
 * @param {string} value
 * @return {!proto.reportpb.Activity} returns this
 */
proto.reportpb.Activity.prototype.setCurrencyAmt = function(value) {
  return jspb.Message.setProto3StringField(this, 79, value);
};


/**
 * optional string exec_id = 80;
 * @return {string}
 */
proto.reportpb.Activity.prototype.getExecId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 80, ""));
};


/**
 * @param {string} value
 * @return {!proto.reportpb.Activity} returns this
 */
proto.reportpb.Activity.prototype.setExecId = function(value) {
  return jspb.Message.setProto3StringField(this, 80, value);
};


/**
 * optional string leg_id = 81;
 * @return {string}
 */
proto.reportpb.Activity.prototype.getLegId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 81, ""));
};


/**
 * @param {string} value
 * @return {!proto.reportpb.Activity} returns this
 */
proto.reportpb.Activity.prototype.setLegId = function(value) {
  return jspb.Message.setProto3StringField(this, 81, value);
};


/**
 * optional string settlement_method = 82;
 * @return {string}
 */
proto.reportpb.Activity.prototype.getSettlementMethod = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 82, ""));
};


/**
 * @param {string} value
 * @return {!proto.reportpb.Activity} returns this
 */
proto.reportpb.Activity.prototype.setSettlementMethod = function(value) {
  return jspb.Message.setProto3StringField(this, 82, value);
};


/**
 * optional bool is_solicited = 83;
 * @return {boolean}
 */
proto.reportpb.Activity.prototype.getIsSolicited = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 83, false));
};


/**
 * @param {boolean} value
 * @return {!proto.reportpb.Activity} returns this
 */
proto.reportpb.Activity.prototype.setIsSolicited = function(value) {
  return jspb.Message.setProto3BooleanField(this, 83, value);
};


/**
 * optional bool step_indicator = 84;
 * @return {boolean}
 */
proto.reportpb.Activity.prototype.getStepIndicator = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 84, false));
};


/**
 * @param {boolean} value
 * @return {!proto.reportpb.Activity} returns this
 */
proto.reportpb.Activity.prototype.setStepIndicator = function(value) {
  return jspb.Message.setProto3BooleanField(this, 84, value);
};


/**
 * optional bool comparison_indicator = 85;
 * @return {boolean}
 */
proto.reportpb.Activity.prototype.getComparisonIndicator = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 85, false));
};


/**
 * @param {boolean} value
 * @return {!proto.reportpb.Activity} returns this
 */
proto.reportpb.Activity.prototype.setComparisonIndicator = function(value) {
  return jspb.Message.setProto3BooleanField(this, 85, value);
};


/**
 * optional bool no_remuneration = 86;
 * @return {boolean}
 */
proto.reportpb.Activity.prototype.getNoRemuneration = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 86, false));
};


/**
 * @param {boolean} value
 * @return {!proto.reportpb.Activity} returns this
 */
proto.reportpb.Activity.prototype.setNoRemuneration = function(value) {
  return jspb.Message.setProto3BooleanField(this, 86, value);
};


/**
 * optional bool when_issue = 87;
 * @return {boolean}
 */
proto.reportpb.Activity.prototype.getWhenIssue = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 87, false));
};


/**
 * @param {boolean} value
 * @return {!proto.reportpb.Activity} returns this
 */
proto.reportpb.Activity.prototype.setWhenIssue = function(value) {
  return jspb.Message.setProto3BooleanField(this, 87, value);
};


/**
 * optional bool new_issue = 88;
 * @return {boolean}
 */
proto.reportpb.Activity.prototype.getNewIssue = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 88, false));
};


/**
 * @param {boolean} value
 * @return {!proto.reportpb.Activity} returns this
 */
proto.reportpb.Activity.prototype.setNewIssue = function(value) {
  return jspb.Message.setProto3BooleanField(this, 88, value);
};


/**
 * optional bool is_msrb = 89;
 * @return {boolean}
 */
proto.reportpb.Activity.prototype.getIsMsrb = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 89, false));
};


/**
 * @param {boolean} value
 * @return {!proto.reportpb.Activity} returns this
 */
proto.reportpb.Activity.prototype.setIsMsrb = function(value) {
  return jspb.Message.setProto3BooleanField(this, 89, value);
};


/**
 * optional bool is_corp = 90;
 * @return {boolean}
 */
proto.reportpb.Activity.prototype.getIsCorp = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 90, false));
};


/**
 * @param {boolean} value
 * @return {!proto.reportpb.Activity} returns this
 */
proto.reportpb.Activity.prototype.setIsCorp = function(value) {
  return jspb.Message.setProto3BooleanField(this, 90, value);
};


/**
 * optional string ytc = 91;
 * @return {string}
 */
proto.reportpb.Activity.prototype.getYtc = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 91, ""));
};


/**
 * @param {string} value
 * @return {!proto.reportpb.Activity} returns this
 */
proto.reportpb.Activity.prototype.setYtc = function(value) {
  return jspb.Message.setProto3StringField(this, 91, value);
};


/**
 * optional string ytm = 92;
 * @return {string}
 */
proto.reportpb.Activity.prototype.getYtm = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 92, ""));
};


/**
 * @param {string} value
 * @return {!proto.reportpb.Activity} returns this
 */
proto.reportpb.Activity.prototype.setYtm = function(value) {
  return jspb.Message.setProto3StringField(this, 92, value);
};


/**
 * optional string mark_amount = 93;
 * @return {string}
 */
proto.reportpb.Activity.prototype.getMarkAmount = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 93, ""));
};


/**
 * @param {string} value
 * @return {!proto.reportpb.Activity} returns this
 */
proto.reportpb.Activity.prototype.setMarkAmount = function(value) {
  return jspb.Message.setProto3StringField(this, 93, value);
};


/**
 * optional string pmp = 94;
 * @return {string}
 */
proto.reportpb.Activity.prototype.getPmp = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 94, ""));
};


/**
 * @param {string} value
 * @return {!proto.reportpb.Activity} returns this
 */
proto.reportpb.Activity.prototype.setPmp = function(value) {
  return jspb.Message.setProto3StringField(this, 94, value);
};


/**
 * optional string mark_rate = 95;
 * @return {string}
 */
proto.reportpb.Activity.prototype.getMarkRate = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 95, ""));
};


/**
 * @param {string} value
 * @return {!proto.reportpb.Activity} returns this
 */
proto.reportpb.Activity.prototype.setMarkRate = function(value) {
  return jspb.Message.setProto3StringField(this, 95, value);
};


/**
 * optional string ats_identifier = 96;
 * @return {string}
 */
proto.reportpb.Activity.prototype.getAtsIdentifier = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 96, ""));
};


/**
 * @param {string} value
 * @return {!proto.reportpb.Activity} returns this
 */
proto.reportpb.Activity.prototype.setAtsIdentifier = function(value) {
  return jspb.Message.setProto3StringField(this, 96, value);
};


/**
 * optional string currency_gross_amt = 97;
 * @return {string}
 */
proto.reportpb.Activity.prototype.getCurrencyGrossAmt = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 97, ""));
};


/**
 * @param {string} value
 * @return {!proto.reportpb.Activity} returns this
 */
proto.reportpb.Activity.prototype.setCurrencyGrossAmt = function(value) {
  return jspb.Message.setProto3StringField(this, 97, value);
};


/**
 * optional string currency_fees = 98;
 * @return {string}
 */
proto.reportpb.Activity.prototype.getCurrencyFees = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 98, ""));
};


/**
 * @param {string} value
 * @return {!proto.reportpb.Activity} returns this
 */
proto.reportpb.Activity.prototype.setCurrencyFees = function(value) {
  return jspb.Message.setProto3StringField(this, 98, value);
};


/**
 * repeated string other_fee_values = 100;
 * @return {!Array<string>}
 */
proto.reportpb.Activity.prototype.getOtherFeeValuesList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 100));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.reportpb.Activity} returns this
 */
proto.reportpb.Activity.prototype.setOtherFeeValuesList = function(value) {
  return jspb.Message.setField(this, 100, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.reportpb.Activity} returns this
 */
proto.reportpb.Activity.prototype.addOtherFeeValues = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 100, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.reportpb.Activity} returns this
 */
proto.reportpb.Activity.prototype.clearOtherFeeValuesList = function() {
  return this.setOtherFeeValuesList([]);
};


/**
 * optional string euroclear_id = 101;
 * @return {string}
 */
proto.reportpb.Activity.prototype.getEuroclearId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 101, ""));
};


/**
 * @param {string} value
 * @return {!proto.reportpb.Activity} returns this
 */
proto.reportpb.Activity.prototype.setEuroclearId = function(value) {
  return jspb.Message.setProto3StringField(this, 101, value);
};


/**
 * optional uint32 settlement_instruction_id = 102;
 * @return {number}
 */
proto.reportpb.Activity.prototype.getSettlementInstructionId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 102, 0));
};


/**
 * @param {number} value
 * @return {!proto.reportpb.Activity} returns this
 */
proto.reportpb.Activity.prototype.setSettlementInstructionId = function(value) {
  return jspb.Message.setProto3IntField(this, 102, value);
};


/**
 * optional string order_type = 103;
 * @return {string}
 */
proto.reportpb.Activity.prototype.getOrderType = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 103, ""));
};


/**
 * @param {string} value
 * @return {!proto.reportpb.Activity} returns this
 */
proto.reportpb.Activity.prototype.setOrderType = function(value) {
  return jspb.Message.setProto3StringField(this, 103, value);
};


/**
 * optional string account_type = 104;
 * @return {string}
 */
proto.reportpb.Activity.prototype.getAccountType = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 104, ""));
};


/**
 * @param {string} value
 * @return {!proto.reportpb.Activity} returns this
 */
proto.reportpb.Activity.prototype.setAccountType = function(value) {
  return jspb.Message.setProto3StringField(this, 104, value);
};


/**
 * optional string contra_broker_no = 105;
 * @return {string}
 */
proto.reportpb.Activity.prototype.getContraBrokerNo = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 105, ""));
};


/**
 * @param {string} value
 * @return {!proto.reportpb.Activity} returns this
 */
proto.reportpb.Activity.prototype.setContraBrokerNo = function(value) {
  return jspb.Message.setProto3StringField(this, 105, value);
};


/**
 * optional string margin_type = 106;
 * @return {string}
 */
proto.reportpb.Activity.prototype.getMarginType = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 106, ""));
};


/**
 * @param {string} value
 * @return {!proto.reportpb.Activity} returns this
 */
proto.reportpb.Activity.prototype.setMarginType = function(value) {
  return jspb.Message.setProto3StringField(this, 106, value);
};


/**
 * optional uint32 sub_account_type = 107;
 * @return {number}
 */
proto.reportpb.Activity.prototype.getSubAccountType = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 107, 0));
};


/**
 * @param {number} value
 * @return {!proto.reportpb.Activity} returns this
 */
proto.reportpb.Activity.prototype.setSubAccountType = function(value) {
  return jspb.Message.setProto3IntField(this, 107, value);
};


/**
 * optional string other_fees_list = 108;
 * @return {string}
 */
proto.reportpb.Activity.prototype.getOtherFeesList = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 108, ""));
};


/**
 * @param {string} value
 * @return {!proto.reportpb.Activity} returns this
 */
proto.reportpb.Activity.prototype.setOtherFeesList = function(value) {
  return jspb.Message.setProto3StringField(this, 108, value);
};


/**
 * optional uint32 dvp_confirm_no = 109;
 * @return {number}
 */
proto.reportpb.Activity.prototype.getDvpConfirmNo = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 109, 0));
};


/**
 * @param {number} value
 * @return {!proto.reportpb.Activity} returns this
 */
proto.reportpb.Activity.prototype.setDvpConfirmNo = function(value) {
  return jspb.Message.setProto3IntField(this, 109, value);
};


/**
 * optional bool is_open_item = 110;
 * @return {boolean}
 */
proto.reportpb.Activity.prototype.getIsOpenItem = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 110, false));
};


/**
 * @param {boolean} value
 * @return {!proto.reportpb.Activity} returns this
 */
proto.reportpb.Activity.prototype.setIsOpenItem = function(value) {
  return jspb.Message.setProto3BooleanField(this, 110, value);
};


/**
 * optional string dvp_external_id = 111;
 * @return {string}
 */
proto.reportpb.Activity.prototype.getDvpExternalId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 111, ""));
};


/**
 * @param {string} value
 * @return {!proto.reportpb.Activity} returns this
 */
proto.reportpb.Activity.prototype.setDvpExternalId = function(value) {
  return jspb.Message.setProto3StringField(this, 111, value);
};


/**
 * optional bool is_archived = 112;
 * @return {boolean}
 */
proto.reportpb.Activity.prototype.getIsArchived = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 112, false));
};


/**
 * @param {boolean} value
 * @return {!proto.reportpb.Activity} returns this
 */
proto.reportpb.Activity.prototype.setIsArchived = function(value) {
  return jspb.Message.setProto3BooleanField(this, 112, value);
};


/**
 * optional string internal_note = 113;
 * @return {string}
 */
proto.reportpb.Activity.prototype.getInternalNote = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 113, ""));
};


/**
 * @param {string} value
 * @return {!proto.reportpb.Activity} returns this
 */
proto.reportpb.Activity.prototype.setInternalNote = function(value) {
  return jspb.Message.setProto3StringField(this, 113, value);
};


/**
 * optional google.type.Date eff_atl_trade_date = 114;
 * @return {?proto.google.type.Date}
 */
proto.reportpb.Activity.prototype.getEffAtlTradeDate = function() {
  return /** @type{?proto.google.type.Date} */ (
    jspb.Message.getWrapperField(this, google_type_date_pb.Date, 114));
};


/**
 * @param {?proto.google.type.Date|undefined} value
 * @return {!proto.reportpb.Activity} returns this
*/
proto.reportpb.Activity.prototype.setEffAtlTradeDate = function(value) {
  return jspb.Message.setWrapperField(this, 114, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.reportpb.Activity} returns this
 */
proto.reportpb.Activity.prototype.clearEffAtlTradeDate = function() {
  return this.setEffAtlTradeDate(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.reportpb.Activity.prototype.hasEffAtlTradeDate = function() {
  return jspb.Message.getField(this, 114) != null;
};


/**
 * optional google.type.Date eff_atl_settle_date = 115;
 * @return {?proto.google.type.Date}
 */
proto.reportpb.Activity.prototype.getEffAtlSettleDate = function() {
  return /** @type{?proto.google.type.Date} */ (
    jspb.Message.getWrapperField(this, google_type_date_pb.Date, 115));
};


/**
 * @param {?proto.google.type.Date|undefined} value
 * @return {!proto.reportpb.Activity} returns this
*/
proto.reportpb.Activity.prototype.setEffAtlSettleDate = function(value) {
  return jspb.Message.setWrapperField(this, 115, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.reportpb.Activity} returns this
 */
proto.reportpb.Activity.prototype.clearEffAtlSettleDate = function() {
  return this.setEffAtlSettleDate(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.reportpb.Activity.prototype.hasEffAtlSettleDate = function() {
  return jspb.Message.getField(this, 115) != null;
};


/**
 * optional string source = 116;
 * @return {string}
 */
proto.reportpb.Activity.prototype.getSource = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 116, ""));
};


/**
 * @param {string} value
 * @return {!proto.reportpb.Activity} returns this
 */
proto.reportpb.Activity.prototype.setSource = function(value) {
  return jspb.Message.setProto3StringField(this, 116, value);
};


/**
 * optional string execution_qty = 117;
 * @return {string}
 */
proto.reportpb.Activity.prototype.getExecutionQty = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 117, ""));
};


/**
 * @param {string} value
 * @return {!proto.reportpb.Activity} returns this
 */
proto.reportpb.Activity.prototype.setExecutionQty = function(value) {
  return jspb.Message.setProto3StringField(this, 117, value);
};


/**
 * optional string execution_net_amt = 118;
 * @return {string}
 */
proto.reportpb.Activity.prototype.getExecutionNetAmt = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 118, ""));
};


/**
 * @param {string} value
 * @return {!proto.reportpb.Activity} returns this
 */
proto.reportpb.Activity.prototype.setExecutionNetAmt = function(value) {
  return jspb.Message.setProto3StringField(this, 118, value);
};


/**
 * optional uint32 report_activity_id = 119;
 * @return {number}
 */
proto.reportpb.Activity.prototype.getReportActivityId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 119, 0));
};


/**
 * @param {number} value
 * @return {!proto.reportpb.Activity} returns this
 */
proto.reportpb.Activity.prototype.setReportActivityId = function(value) {
  return jspb.Message.setProto3IntField(this, 119, value);
};


/**
 * optional string ctm_party_value = 120;
 * @return {string}
 */
proto.reportpb.Activity.prototype.getCtmPartyValue = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 120, ""));
};


/**
 * @param {string} value
 * @return {!proto.reportpb.Activity} returns this
 */
proto.reportpb.Activity.prototype.setCtmPartyValue = function(value) {
  return jspb.Message.setProto3StringField(this, 120, value);
};


/**
 * optional string master_reference = 121;
 * @return {string}
 */
proto.reportpb.Activity.prototype.getMasterReference = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 121, ""));
};


/**
 * @param {string} value
 * @return {!proto.reportpb.Activity} returns this
 */
proto.reportpb.Activity.prototype.setMasterReference = function(value) {
  return jspb.Message.setProto3StringField(this, 121, value);
};


/**
 * optional string repo_rate = 122;
 * @return {string}
 */
proto.reportpb.Activity.prototype.getRepoRate = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 122, ""));
};


/**
 * @param {string} value
 * @return {!proto.reportpb.Activity} returns this
 */
proto.reportpb.Activity.prototype.setRepoRate = function(value) {
  return jspb.Message.setProto3StringField(this, 122, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.reportpb.ActivityReportDetails.prototype.toObject = function(opt_includeInstance) {
  return proto.reportpb.ActivityReportDetails.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.reportpb.ActivityReportDetails} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.reportpb.ActivityReportDetails.toObject = function(includeInstance, msg) {
  var f, obj = {
    reportActivityId: jspb.Message.getFieldWithDefault(msg, 1, 0),
    systemDate: (f = msg.getSystemDate()) && google_type_date_pb.Date.toObject(includeInstance, f),
    entryTypeDescription: jspb.Message.getFieldWithDefault(msg, 3, ""),
    symbolDescription: jspb.Message.getFieldWithDefault(msg, 4, ""),
    batchNo: jspb.Message.getFieldWithDefault(msg, 5, ""),
    product: jspb.Message.getFieldWithDefault(msg, 6, ""),
    accrual: jspb.Message.getFieldWithDefault(msg, 7, ""),
    couponRate: jspb.Message.getFieldWithDefault(msg, 8, ""),
    orgType: jspb.Message.getFieldWithDefault(msg, 9, ""),
    orgTerm: (f = msg.getOrgTerm()) && google_type_date_pb.Date.toObject(includeInstance, f),
    cumQty: jspb.Message.getFieldWithDefault(msg, 11, ""),
    leavesQty: jspb.Message.getFieldWithDefault(msg, 12, ""),
    delivered: jspb.Message.getBooleanFieldWithDefault(msg, 13, false),
    s3: jspb.Message.getBooleanFieldWithDefault(msg, 14, false),
    taxRate: jspb.Message.getFieldWithDefault(msg, 15, ""),
    discretion: jspb.Message.getFieldWithDefault(msg, 16, ""),
    execId: jspb.Message.getFieldWithDefault(msg, 17, ""),
    legId: jspb.Message.getFieldWithDefault(msg, 18, ""),
    isSolicited: jspb.Message.getBooleanFieldWithDefault(msg, 19, false),
    stepIndicator: jspb.Message.getBooleanFieldWithDefault(msg, 20, false),
    comparisonIndicator: jspb.Message.getBooleanFieldWithDefault(msg, 21, false),
    noRemuneration: jspb.Message.getBooleanFieldWithDefault(msg, 22, false),
    whenIssue: jspb.Message.getBooleanFieldWithDefault(msg, 23, false),
    newIssue: jspb.Message.getBooleanFieldWithDefault(msg, 24, false),
    isMsrb: jspb.Message.getBooleanFieldWithDefault(msg, 25, false),
    isCorp: jspb.Message.getBooleanFieldWithDefault(msg, 26, false),
    ytc: jspb.Message.getFieldWithDefault(msg, 27, ""),
    ytm: jspb.Message.getFieldWithDefault(msg, 28, ""),
    markAmount: jspb.Message.getFieldWithDefault(msg, 29, ""),
    pmp: jspb.Message.getFieldWithDefault(msg, 30, ""),
    markRate: jspb.Message.getFieldWithDefault(msg, 31, ""),
    atsIdentifier: jspb.Message.getFieldWithDefault(msg, 32, ""),
    currencyGrossAmt: jspb.Message.getFieldWithDefault(msg, 33, ""),
    currencyFees: jspb.Message.getFieldWithDefault(msg, 34, ""),
    euroclearId: jspb.Message.getFieldWithDefault(msg, 35, 0),
    createdByApi: jspb.Message.getFieldWithDefault(msg, 36, ""),
    orderType: jspb.Message.getFieldWithDefault(msg, 37, ""),
    securityType: jspb.Message.getFieldWithDefault(msg, 38, ""),
    classification: jspb.Message.getFieldWithDefault(msg, 39, ""),
    isOpenItem: jspb.Message.getBooleanFieldWithDefault(msg, 40, false),
    contraType: jspb.Message.getFieldWithDefault(msg, 41, ""),
    isSyndicate: jspb.Message.getBooleanFieldWithDefault(msg, 42, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.reportpb.ActivityReportDetails}
 */
proto.reportpb.ActivityReportDetails.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.reportpb.ActivityReportDetails;
  return proto.reportpb.ActivityReportDetails.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.reportpb.ActivityReportDetails} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.reportpb.ActivityReportDetails}
 */
proto.reportpb.ActivityReportDetails.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setReportActivityId(value);
      break;
    case 2:
      var value = new google_type_date_pb.Date;
      reader.readMessage(value,google_type_date_pb.Date.deserializeBinaryFromReader);
      msg.setSystemDate(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setEntryTypeDescription(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setSymbolDescription(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setBatchNo(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setProduct(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.setAccrual(value);
      break;
    case 8:
      var value = /** @type {string} */ (reader.readString());
      msg.setCouponRate(value);
      break;
    case 9:
      var value = /** @type {string} */ (reader.readString());
      msg.setOrgType(value);
      break;
    case 10:
      var value = new google_type_date_pb.Date;
      reader.readMessage(value,google_type_date_pb.Date.deserializeBinaryFromReader);
      msg.setOrgTerm(value);
      break;
    case 11:
      var value = /** @type {string} */ (reader.readString());
      msg.setCumQty(value);
      break;
    case 12:
      var value = /** @type {string} */ (reader.readString());
      msg.setLeavesQty(value);
      break;
    case 13:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setDelivered(value);
      break;
    case 14:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setS3(value);
      break;
    case 15:
      var value = /** @type {string} */ (reader.readString());
      msg.setTaxRate(value);
      break;
    case 16:
      var value = /** @type {string} */ (reader.readString());
      msg.setDiscretion(value);
      break;
    case 17:
      var value = /** @type {string} */ (reader.readString());
      msg.setExecId(value);
      break;
    case 18:
      var value = /** @type {string} */ (reader.readString());
      msg.setLegId(value);
      break;
    case 19:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIsSolicited(value);
      break;
    case 20:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setStepIndicator(value);
      break;
    case 21:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setComparisonIndicator(value);
      break;
    case 22:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setNoRemuneration(value);
      break;
    case 23:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setWhenIssue(value);
      break;
    case 24:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setNewIssue(value);
      break;
    case 25:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIsMsrb(value);
      break;
    case 26:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIsCorp(value);
      break;
    case 27:
      var value = /** @type {string} */ (reader.readString());
      msg.setYtc(value);
      break;
    case 28:
      var value = /** @type {string} */ (reader.readString());
      msg.setYtm(value);
      break;
    case 29:
      var value = /** @type {string} */ (reader.readString());
      msg.setMarkAmount(value);
      break;
    case 30:
      var value = /** @type {string} */ (reader.readString());
      msg.setPmp(value);
      break;
    case 31:
      var value = /** @type {string} */ (reader.readString());
      msg.setMarkRate(value);
      break;
    case 32:
      var value = /** @type {string} */ (reader.readString());
      msg.setAtsIdentifier(value);
      break;
    case 33:
      var value = /** @type {string} */ (reader.readString());
      msg.setCurrencyGrossAmt(value);
      break;
    case 34:
      var value = /** @type {string} */ (reader.readString());
      msg.setCurrencyFees(value);
      break;
    case 35:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setEuroclearId(value);
      break;
    case 36:
      var value = /** @type {string} */ (reader.readString());
      msg.setCreatedByApi(value);
      break;
    case 37:
      var value = /** @type {string} */ (reader.readString());
      msg.setOrderType(value);
      break;
    case 38:
      var value = /** @type {string} */ (reader.readString());
      msg.setSecurityType(value);
      break;
    case 39:
      var value = /** @type {string} */ (reader.readString());
      msg.setClassification(value);
      break;
    case 40:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIsOpenItem(value);
      break;
    case 41:
      var value = /** @type {string} */ (reader.readString());
      msg.setContraType(value);
      break;
    case 42:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIsSyndicate(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.reportpb.ActivityReportDetails.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.reportpb.ActivityReportDetails.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.reportpb.ActivityReportDetails} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.reportpb.ActivityReportDetails.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getReportActivityId();
  if (f !== 0) {
    writer.writeUint32(
      1,
      f
    );
  }
  f = message.getSystemDate();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      google_type_date_pb.Date.serializeBinaryToWriter
    );
  }
  f = message.getEntryTypeDescription();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getSymbolDescription();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getBatchNo();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getProduct();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getAccrual();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
  f = message.getCouponRate();
  if (f.length > 0) {
    writer.writeString(
      8,
      f
    );
  }
  f = message.getOrgType();
  if (f.length > 0) {
    writer.writeString(
      9,
      f
    );
  }
  f = message.getOrgTerm();
  if (f != null) {
    writer.writeMessage(
      10,
      f,
      google_type_date_pb.Date.serializeBinaryToWriter
    );
  }
  f = message.getCumQty();
  if (f.length > 0) {
    writer.writeString(
      11,
      f
    );
  }
  f = message.getLeavesQty();
  if (f.length > 0) {
    writer.writeString(
      12,
      f
    );
  }
  f = message.getDelivered();
  if (f) {
    writer.writeBool(
      13,
      f
    );
  }
  f = message.getS3();
  if (f) {
    writer.writeBool(
      14,
      f
    );
  }
  f = message.getTaxRate();
  if (f.length > 0) {
    writer.writeString(
      15,
      f
    );
  }
  f = message.getDiscretion();
  if (f.length > 0) {
    writer.writeString(
      16,
      f
    );
  }
  f = message.getExecId();
  if (f.length > 0) {
    writer.writeString(
      17,
      f
    );
  }
  f = message.getLegId();
  if (f.length > 0) {
    writer.writeString(
      18,
      f
    );
  }
  f = message.getIsSolicited();
  if (f) {
    writer.writeBool(
      19,
      f
    );
  }
  f = message.getStepIndicator();
  if (f) {
    writer.writeBool(
      20,
      f
    );
  }
  f = message.getComparisonIndicator();
  if (f) {
    writer.writeBool(
      21,
      f
    );
  }
  f = message.getNoRemuneration();
  if (f) {
    writer.writeBool(
      22,
      f
    );
  }
  f = message.getWhenIssue();
  if (f) {
    writer.writeBool(
      23,
      f
    );
  }
  f = message.getNewIssue();
  if (f) {
    writer.writeBool(
      24,
      f
    );
  }
  f = message.getIsMsrb();
  if (f) {
    writer.writeBool(
      25,
      f
    );
  }
  f = message.getIsCorp();
  if (f) {
    writer.writeBool(
      26,
      f
    );
  }
  f = message.getYtc();
  if (f.length > 0) {
    writer.writeString(
      27,
      f
    );
  }
  f = message.getYtm();
  if (f.length > 0) {
    writer.writeString(
      28,
      f
    );
  }
  f = message.getMarkAmount();
  if (f.length > 0) {
    writer.writeString(
      29,
      f
    );
  }
  f = message.getPmp();
  if (f.length > 0) {
    writer.writeString(
      30,
      f
    );
  }
  f = message.getMarkRate();
  if (f.length > 0) {
    writer.writeString(
      31,
      f
    );
  }
  f = message.getAtsIdentifier();
  if (f.length > 0) {
    writer.writeString(
      32,
      f
    );
  }
  f = message.getCurrencyGrossAmt();
  if (f.length > 0) {
    writer.writeString(
      33,
      f
    );
  }
  f = message.getCurrencyFees();
  if (f.length > 0) {
    writer.writeString(
      34,
      f
    );
  }
  f = message.getEuroclearId();
  if (f !== 0) {
    writer.writeUint32(
      35,
      f
    );
  }
  f = message.getCreatedByApi();
  if (f.length > 0) {
    writer.writeString(
      36,
      f
    );
  }
  f = message.getOrderType();
  if (f.length > 0) {
    writer.writeString(
      37,
      f
    );
  }
  f = message.getSecurityType();
  if (f.length > 0) {
    writer.writeString(
      38,
      f
    );
  }
  f = message.getClassification();
  if (f.length > 0) {
    writer.writeString(
      39,
      f
    );
  }
  f = message.getIsOpenItem();
  if (f) {
    writer.writeBool(
      40,
      f
    );
  }
  f = message.getContraType();
  if (f.length > 0) {
    writer.writeString(
      41,
      f
    );
  }
  f = message.getIsSyndicate();
  if (f) {
    writer.writeBool(
      42,
      f
    );
  }
};


/**
 * optional uint32 report_activity_id = 1;
 * @return {number}
 */
proto.reportpb.ActivityReportDetails.prototype.getReportActivityId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.reportpb.ActivityReportDetails} returns this
 */
proto.reportpb.ActivityReportDetails.prototype.setReportActivityId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional google.type.Date system_date = 2;
 * @return {?proto.google.type.Date}
 */
proto.reportpb.ActivityReportDetails.prototype.getSystemDate = function() {
  return /** @type{?proto.google.type.Date} */ (
    jspb.Message.getWrapperField(this, google_type_date_pb.Date, 2));
};


/**
 * @param {?proto.google.type.Date|undefined} value
 * @return {!proto.reportpb.ActivityReportDetails} returns this
*/
proto.reportpb.ActivityReportDetails.prototype.setSystemDate = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.reportpb.ActivityReportDetails} returns this
 */
proto.reportpb.ActivityReportDetails.prototype.clearSystemDate = function() {
  return this.setSystemDate(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.reportpb.ActivityReportDetails.prototype.hasSystemDate = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional string entry_type_description = 3;
 * @return {string}
 */
proto.reportpb.ActivityReportDetails.prototype.getEntryTypeDescription = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.reportpb.ActivityReportDetails} returns this
 */
proto.reportpb.ActivityReportDetails.prototype.setEntryTypeDescription = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string symbol_description = 4;
 * @return {string}
 */
proto.reportpb.ActivityReportDetails.prototype.getSymbolDescription = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.reportpb.ActivityReportDetails} returns this
 */
proto.reportpb.ActivityReportDetails.prototype.setSymbolDescription = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string batch_no = 5;
 * @return {string}
 */
proto.reportpb.ActivityReportDetails.prototype.getBatchNo = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.reportpb.ActivityReportDetails} returns this
 */
proto.reportpb.ActivityReportDetails.prototype.setBatchNo = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional string product = 6;
 * @return {string}
 */
proto.reportpb.ActivityReportDetails.prototype.getProduct = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.reportpb.ActivityReportDetails} returns this
 */
proto.reportpb.ActivityReportDetails.prototype.setProduct = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * optional string accrual = 7;
 * @return {string}
 */
proto.reportpb.ActivityReportDetails.prototype.getAccrual = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/**
 * @param {string} value
 * @return {!proto.reportpb.ActivityReportDetails} returns this
 */
proto.reportpb.ActivityReportDetails.prototype.setAccrual = function(value) {
  return jspb.Message.setProto3StringField(this, 7, value);
};


/**
 * optional string coupon_rate = 8;
 * @return {string}
 */
proto.reportpb.ActivityReportDetails.prototype.getCouponRate = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 8, ""));
};


/**
 * @param {string} value
 * @return {!proto.reportpb.ActivityReportDetails} returns this
 */
proto.reportpb.ActivityReportDetails.prototype.setCouponRate = function(value) {
  return jspb.Message.setProto3StringField(this, 8, value);
};


/**
 * optional string org_type = 9;
 * @return {string}
 */
proto.reportpb.ActivityReportDetails.prototype.getOrgType = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 9, ""));
};


/**
 * @param {string} value
 * @return {!proto.reportpb.ActivityReportDetails} returns this
 */
proto.reportpb.ActivityReportDetails.prototype.setOrgType = function(value) {
  return jspb.Message.setProto3StringField(this, 9, value);
};


/**
 * optional google.type.Date org_term = 10;
 * @return {?proto.google.type.Date}
 */
proto.reportpb.ActivityReportDetails.prototype.getOrgTerm = function() {
  return /** @type{?proto.google.type.Date} */ (
    jspb.Message.getWrapperField(this, google_type_date_pb.Date, 10));
};


/**
 * @param {?proto.google.type.Date|undefined} value
 * @return {!proto.reportpb.ActivityReportDetails} returns this
*/
proto.reportpb.ActivityReportDetails.prototype.setOrgTerm = function(value) {
  return jspb.Message.setWrapperField(this, 10, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.reportpb.ActivityReportDetails} returns this
 */
proto.reportpb.ActivityReportDetails.prototype.clearOrgTerm = function() {
  return this.setOrgTerm(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.reportpb.ActivityReportDetails.prototype.hasOrgTerm = function() {
  return jspb.Message.getField(this, 10) != null;
};


/**
 * optional string cum_qty = 11;
 * @return {string}
 */
proto.reportpb.ActivityReportDetails.prototype.getCumQty = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 11, ""));
};


/**
 * @param {string} value
 * @return {!proto.reportpb.ActivityReportDetails} returns this
 */
proto.reportpb.ActivityReportDetails.prototype.setCumQty = function(value) {
  return jspb.Message.setProto3StringField(this, 11, value);
};


/**
 * optional string leaves_qty = 12;
 * @return {string}
 */
proto.reportpb.ActivityReportDetails.prototype.getLeavesQty = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 12, ""));
};


/**
 * @param {string} value
 * @return {!proto.reportpb.ActivityReportDetails} returns this
 */
proto.reportpb.ActivityReportDetails.prototype.setLeavesQty = function(value) {
  return jspb.Message.setProto3StringField(this, 12, value);
};


/**
 * optional bool delivered = 13;
 * @return {boolean}
 */
proto.reportpb.ActivityReportDetails.prototype.getDelivered = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 13, false));
};


/**
 * @param {boolean} value
 * @return {!proto.reportpb.ActivityReportDetails} returns this
 */
proto.reportpb.ActivityReportDetails.prototype.setDelivered = function(value) {
  return jspb.Message.setProto3BooleanField(this, 13, value);
};


/**
 * optional bool s3 = 14;
 * @return {boolean}
 */
proto.reportpb.ActivityReportDetails.prototype.getS3 = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 14, false));
};


/**
 * @param {boolean} value
 * @return {!proto.reportpb.ActivityReportDetails} returns this
 */
proto.reportpb.ActivityReportDetails.prototype.setS3 = function(value) {
  return jspb.Message.setProto3BooleanField(this, 14, value);
};


/**
 * optional string tax_rate = 15;
 * @return {string}
 */
proto.reportpb.ActivityReportDetails.prototype.getTaxRate = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 15, ""));
};


/**
 * @param {string} value
 * @return {!proto.reportpb.ActivityReportDetails} returns this
 */
proto.reportpb.ActivityReportDetails.prototype.setTaxRate = function(value) {
  return jspb.Message.setProto3StringField(this, 15, value);
};


/**
 * optional string discretion = 16;
 * @return {string}
 */
proto.reportpb.ActivityReportDetails.prototype.getDiscretion = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 16, ""));
};


/**
 * @param {string} value
 * @return {!proto.reportpb.ActivityReportDetails} returns this
 */
proto.reportpb.ActivityReportDetails.prototype.setDiscretion = function(value) {
  return jspb.Message.setProto3StringField(this, 16, value);
};


/**
 * optional string exec_id = 17;
 * @return {string}
 */
proto.reportpb.ActivityReportDetails.prototype.getExecId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 17, ""));
};


/**
 * @param {string} value
 * @return {!proto.reportpb.ActivityReportDetails} returns this
 */
proto.reportpb.ActivityReportDetails.prototype.setExecId = function(value) {
  return jspb.Message.setProto3StringField(this, 17, value);
};


/**
 * optional string leg_id = 18;
 * @return {string}
 */
proto.reportpb.ActivityReportDetails.prototype.getLegId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 18, ""));
};


/**
 * @param {string} value
 * @return {!proto.reportpb.ActivityReportDetails} returns this
 */
proto.reportpb.ActivityReportDetails.prototype.setLegId = function(value) {
  return jspb.Message.setProto3StringField(this, 18, value);
};


/**
 * optional bool is_solicited = 19;
 * @return {boolean}
 */
proto.reportpb.ActivityReportDetails.prototype.getIsSolicited = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 19, false));
};


/**
 * @param {boolean} value
 * @return {!proto.reportpb.ActivityReportDetails} returns this
 */
proto.reportpb.ActivityReportDetails.prototype.setIsSolicited = function(value) {
  return jspb.Message.setProto3BooleanField(this, 19, value);
};


/**
 * optional bool step_indicator = 20;
 * @return {boolean}
 */
proto.reportpb.ActivityReportDetails.prototype.getStepIndicator = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 20, false));
};


/**
 * @param {boolean} value
 * @return {!proto.reportpb.ActivityReportDetails} returns this
 */
proto.reportpb.ActivityReportDetails.prototype.setStepIndicator = function(value) {
  return jspb.Message.setProto3BooleanField(this, 20, value);
};


/**
 * optional bool comparison_indicator = 21;
 * @return {boolean}
 */
proto.reportpb.ActivityReportDetails.prototype.getComparisonIndicator = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 21, false));
};


/**
 * @param {boolean} value
 * @return {!proto.reportpb.ActivityReportDetails} returns this
 */
proto.reportpb.ActivityReportDetails.prototype.setComparisonIndicator = function(value) {
  return jspb.Message.setProto3BooleanField(this, 21, value);
};


/**
 * optional bool no_remuneration = 22;
 * @return {boolean}
 */
proto.reportpb.ActivityReportDetails.prototype.getNoRemuneration = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 22, false));
};


/**
 * @param {boolean} value
 * @return {!proto.reportpb.ActivityReportDetails} returns this
 */
proto.reportpb.ActivityReportDetails.prototype.setNoRemuneration = function(value) {
  return jspb.Message.setProto3BooleanField(this, 22, value);
};


/**
 * optional bool when_issue = 23;
 * @return {boolean}
 */
proto.reportpb.ActivityReportDetails.prototype.getWhenIssue = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 23, false));
};


/**
 * @param {boolean} value
 * @return {!proto.reportpb.ActivityReportDetails} returns this
 */
proto.reportpb.ActivityReportDetails.prototype.setWhenIssue = function(value) {
  return jspb.Message.setProto3BooleanField(this, 23, value);
};


/**
 * optional bool new_issue = 24;
 * @return {boolean}
 */
proto.reportpb.ActivityReportDetails.prototype.getNewIssue = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 24, false));
};


/**
 * @param {boolean} value
 * @return {!proto.reportpb.ActivityReportDetails} returns this
 */
proto.reportpb.ActivityReportDetails.prototype.setNewIssue = function(value) {
  return jspb.Message.setProto3BooleanField(this, 24, value);
};


/**
 * optional bool is_msrb = 25;
 * @return {boolean}
 */
proto.reportpb.ActivityReportDetails.prototype.getIsMsrb = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 25, false));
};


/**
 * @param {boolean} value
 * @return {!proto.reportpb.ActivityReportDetails} returns this
 */
proto.reportpb.ActivityReportDetails.prototype.setIsMsrb = function(value) {
  return jspb.Message.setProto3BooleanField(this, 25, value);
};


/**
 * optional bool is_corp = 26;
 * @return {boolean}
 */
proto.reportpb.ActivityReportDetails.prototype.getIsCorp = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 26, false));
};


/**
 * @param {boolean} value
 * @return {!proto.reportpb.ActivityReportDetails} returns this
 */
proto.reportpb.ActivityReportDetails.prototype.setIsCorp = function(value) {
  return jspb.Message.setProto3BooleanField(this, 26, value);
};


/**
 * optional string ytc = 27;
 * @return {string}
 */
proto.reportpb.ActivityReportDetails.prototype.getYtc = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 27, ""));
};


/**
 * @param {string} value
 * @return {!proto.reportpb.ActivityReportDetails} returns this
 */
proto.reportpb.ActivityReportDetails.prototype.setYtc = function(value) {
  return jspb.Message.setProto3StringField(this, 27, value);
};


/**
 * optional string ytm = 28;
 * @return {string}
 */
proto.reportpb.ActivityReportDetails.prototype.getYtm = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 28, ""));
};


/**
 * @param {string} value
 * @return {!proto.reportpb.ActivityReportDetails} returns this
 */
proto.reportpb.ActivityReportDetails.prototype.setYtm = function(value) {
  return jspb.Message.setProto3StringField(this, 28, value);
};


/**
 * optional string mark_amount = 29;
 * @return {string}
 */
proto.reportpb.ActivityReportDetails.prototype.getMarkAmount = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 29, ""));
};


/**
 * @param {string} value
 * @return {!proto.reportpb.ActivityReportDetails} returns this
 */
proto.reportpb.ActivityReportDetails.prototype.setMarkAmount = function(value) {
  return jspb.Message.setProto3StringField(this, 29, value);
};


/**
 * optional string pmp = 30;
 * @return {string}
 */
proto.reportpb.ActivityReportDetails.prototype.getPmp = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 30, ""));
};


/**
 * @param {string} value
 * @return {!proto.reportpb.ActivityReportDetails} returns this
 */
proto.reportpb.ActivityReportDetails.prototype.setPmp = function(value) {
  return jspb.Message.setProto3StringField(this, 30, value);
};


/**
 * optional string mark_rate = 31;
 * @return {string}
 */
proto.reportpb.ActivityReportDetails.prototype.getMarkRate = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 31, ""));
};


/**
 * @param {string} value
 * @return {!proto.reportpb.ActivityReportDetails} returns this
 */
proto.reportpb.ActivityReportDetails.prototype.setMarkRate = function(value) {
  return jspb.Message.setProto3StringField(this, 31, value);
};


/**
 * optional string ats_identifier = 32;
 * @return {string}
 */
proto.reportpb.ActivityReportDetails.prototype.getAtsIdentifier = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 32, ""));
};


/**
 * @param {string} value
 * @return {!proto.reportpb.ActivityReportDetails} returns this
 */
proto.reportpb.ActivityReportDetails.prototype.setAtsIdentifier = function(value) {
  return jspb.Message.setProto3StringField(this, 32, value);
};


/**
 * optional string currency_gross_amt = 33;
 * @return {string}
 */
proto.reportpb.ActivityReportDetails.prototype.getCurrencyGrossAmt = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 33, ""));
};


/**
 * @param {string} value
 * @return {!proto.reportpb.ActivityReportDetails} returns this
 */
proto.reportpb.ActivityReportDetails.prototype.setCurrencyGrossAmt = function(value) {
  return jspb.Message.setProto3StringField(this, 33, value);
};


/**
 * optional string currency_fees = 34;
 * @return {string}
 */
proto.reportpb.ActivityReportDetails.prototype.getCurrencyFees = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 34, ""));
};


/**
 * @param {string} value
 * @return {!proto.reportpb.ActivityReportDetails} returns this
 */
proto.reportpb.ActivityReportDetails.prototype.setCurrencyFees = function(value) {
  return jspb.Message.setProto3StringField(this, 34, value);
};


/**
 * optional uint32 euroclear_id = 35;
 * @return {number}
 */
proto.reportpb.ActivityReportDetails.prototype.getEuroclearId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 35, 0));
};


/**
 * @param {number} value
 * @return {!proto.reportpb.ActivityReportDetails} returns this
 */
proto.reportpb.ActivityReportDetails.prototype.setEuroclearId = function(value) {
  return jspb.Message.setProto3IntField(this, 35, value);
};


/**
 * optional string created_by_api = 36;
 * @return {string}
 */
proto.reportpb.ActivityReportDetails.prototype.getCreatedByApi = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 36, ""));
};


/**
 * @param {string} value
 * @return {!proto.reportpb.ActivityReportDetails} returns this
 */
proto.reportpb.ActivityReportDetails.prototype.setCreatedByApi = function(value) {
  return jspb.Message.setProto3StringField(this, 36, value);
};


/**
 * optional string order_type = 37;
 * @return {string}
 */
proto.reportpb.ActivityReportDetails.prototype.getOrderType = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 37, ""));
};


/**
 * @param {string} value
 * @return {!proto.reportpb.ActivityReportDetails} returns this
 */
proto.reportpb.ActivityReportDetails.prototype.setOrderType = function(value) {
  return jspb.Message.setProto3StringField(this, 37, value);
};


/**
 * optional string security_type = 38;
 * @return {string}
 */
proto.reportpb.ActivityReportDetails.prototype.getSecurityType = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 38, ""));
};


/**
 * @param {string} value
 * @return {!proto.reportpb.ActivityReportDetails} returns this
 */
proto.reportpb.ActivityReportDetails.prototype.setSecurityType = function(value) {
  return jspb.Message.setProto3StringField(this, 38, value);
};


/**
 * optional string classification = 39;
 * @return {string}
 */
proto.reportpb.ActivityReportDetails.prototype.getClassification = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 39, ""));
};


/**
 * @param {string} value
 * @return {!proto.reportpb.ActivityReportDetails} returns this
 */
proto.reportpb.ActivityReportDetails.prototype.setClassification = function(value) {
  return jspb.Message.setProto3StringField(this, 39, value);
};


/**
 * optional bool is_open_item = 40;
 * @return {boolean}
 */
proto.reportpb.ActivityReportDetails.prototype.getIsOpenItem = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 40, false));
};


/**
 * @param {boolean} value
 * @return {!proto.reportpb.ActivityReportDetails} returns this
 */
proto.reportpb.ActivityReportDetails.prototype.setIsOpenItem = function(value) {
  return jspb.Message.setProto3BooleanField(this, 40, value);
};


/**
 * optional string contra_type = 41;
 * @return {string}
 */
proto.reportpb.ActivityReportDetails.prototype.getContraType = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 41, ""));
};


/**
 * @param {string} value
 * @return {!proto.reportpb.ActivityReportDetails} returns this
 */
proto.reportpb.ActivityReportDetails.prototype.setContraType = function(value) {
  return jspb.Message.setProto3StringField(this, 41, value);
};


/**
 * optional bool is_syndicate = 42;
 * @return {boolean}
 */
proto.reportpb.ActivityReportDetails.prototype.getIsSyndicate = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 42, false));
};


/**
 * @param {boolean} value
 * @return {!proto.reportpb.ActivityReportDetails} returns this
 */
proto.reportpb.ActivityReportDetails.prototype.setIsSyndicate = function(value) {
  return jspb.Message.setProto3BooleanField(this, 42, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.reportpb.ListActivityReportDetailsRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.reportpb.ListActivityReportDetailsRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.reportpb.ListActivityReportDetailsRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.reportpb.ListActivityReportDetailsRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    reportActivityId: jspb.Message.getFieldWithDefault(msg, 1, 0),
    isArchived: jspb.Message.getBooleanFieldWithDefault(msg, 2, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.reportpb.ListActivityReportDetailsRequest}
 */
proto.reportpb.ListActivityReportDetailsRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.reportpb.ListActivityReportDetailsRequest;
  return proto.reportpb.ListActivityReportDetailsRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.reportpb.ListActivityReportDetailsRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.reportpb.ListActivityReportDetailsRequest}
 */
proto.reportpb.ListActivityReportDetailsRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setReportActivityId(value);
      break;
    case 2:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIsArchived(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.reportpb.ListActivityReportDetailsRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.reportpb.ListActivityReportDetailsRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.reportpb.ListActivityReportDetailsRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.reportpb.ListActivityReportDetailsRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getReportActivityId();
  if (f !== 0) {
    writer.writeUint32(
      1,
      f
    );
  }
  f = message.getIsArchived();
  if (f) {
    writer.writeBool(
      2,
      f
    );
  }
};


/**
 * optional uint32 report_activity_id = 1;
 * @return {number}
 */
proto.reportpb.ListActivityReportDetailsRequest.prototype.getReportActivityId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.reportpb.ListActivityReportDetailsRequest} returns this
 */
proto.reportpb.ListActivityReportDetailsRequest.prototype.setReportActivityId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional bool is_archived = 2;
 * @return {boolean}
 */
proto.reportpb.ListActivityReportDetailsRequest.prototype.getIsArchived = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 2, false));
};


/**
 * @param {boolean} value
 * @return {!proto.reportpb.ListActivityReportDetailsRequest} returns this
 */
proto.reportpb.ListActivityReportDetailsRequest.prototype.setIsArchived = function(value) {
  return jspb.Message.setProto3BooleanField(this, 2, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.reportpb.ListActivityRequest.repeatedFields_ = [46];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.reportpb.ListActivityRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.reportpb.ListActivityRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.reportpb.ListActivityRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.reportpb.ListActivityRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    correspondent: jspb.Message.getFieldWithDefault(msg, 1, ""),
    accountNo: jspb.Message.getFieldWithDefault(msg, 2, ""),
    contraAccountNo: jspb.Message.getFieldWithDefault(msg, 3, ""),
    masterAccountNo: jspb.Message.getFieldWithDefault(msg, 4, ""),
    asoftrns: jspb.Message.getBooleanFieldWithDefault(msg, 5, false),
    broker: jspb.Message.getFieldWithDefault(msg, 6, ""),
    type: jspb.Message.getFieldWithDefault(msg, 7, ""),
    symbol: jspb.Message.getFieldWithDefault(msg, 8, ""),
    cusip: jspb.Message.getFieldWithDefault(msg, 9, ""),
    status: jspb.Message.getFieldWithDefault(msg, 10, ""),
    dateType: jspb.Message.getFieldWithDefault(msg, 11, ""),
    fromDate: (f = msg.getFromDate()) && google_type_date_pb.Date.toObject(includeInstance, f),
    toDate: (f = msg.getToDate()) && google_type_date_pb.Date.toObject(includeInstance, f),
    entryType: jspb.Message.getFieldWithDefault(msg, 14, ""),
    branch: jspb.Message.getFieldWithDefault(msg, 15, ""),
    rep: jspb.Message.getFieldWithDefault(msg, 16, ""),
    searchType: jspb.Message.getFieldWithDefault(msg, 17, ""),
    compressId: jspb.Message.getFieldWithDefault(msg, 18, 0),
    side: jspb.Message.getFieldWithDefault(msg, 19, ""),
    pagination: (f = msg.getPagination()) && proto_utilspb_pagination_pb.Pagination.toObject(includeInstance, f),
    trnsId: jspb.Message.getFieldWithDefault(msg, 21, 0),
    assetType: jspb.Message.getFieldWithDefault(msg, 22, ""),
    accountId: jspb.Message.getFieldWithDefault(msg, 23, 0),
    description: jspb.Message.getFieldWithDefault(msg, 24, ""),
    referenceId: jspb.Message.getFieldWithDefault(msg, 25, ""),
    participantNo: jspb.Message.getFieldWithDefault(msg, 26, ""),
    batchNo: jspb.Message.getFieldWithDefault(msg, 27, ""),
    transactionSide: jspb.Message.getFieldWithDefault(msg, 28, ""),
    currency: jspb.Message.getFieldWithDefault(msg, 29, ""),
    qtyOnly: jspb.Message.getBooleanFieldWithDefault(msg, 30, false),
    netAmtOnly: jspb.Message.getBooleanFieldWithDefault(msg, 31, false),
    breakdownOtherFees: jspb.Message.getBooleanFieldWithDefault(msg, 32, false),
    subAccountType: jspb.Message.getFieldWithDefault(msg, 34, 0),
    subAccountNo: jspb.Message.getFieldWithDefault(msg, 35, ""),
    effTradeDate: (f = msg.getEffTradeDate()) && google_type_date_pb.Date.toObject(includeInstance, f),
    effSettleDate: (f = msg.getEffSettleDate()) && google_type_date_pb.Date.toObject(includeInstance, f),
    capacity: jspb.Message.getFieldWithDefault(msg, 38, ""),
    contraSubAccountNo: jspb.Message.getFieldWithDefault(msg, 39, ""),
    contraAccountId: jspb.Message.getFieldWithDefault(msg, 40, 0),
    originalCusip: jspb.Message.getFieldWithDefault(msg, 41, ""),
    disableOriginalCusipMapping: jspb.Message.getBooleanFieldWithDefault(msg, 42, false),
    isReused: jspb.Message.getBooleanFieldWithDefault(msg, 43, false),
    dvpExternalId: jspb.Message.getFieldWithDefault(msg, 44, ""),
    createdBy: jspb.Message.getFieldWithDefault(msg, 45, ""),
    includeTrnsIdsList: (f = jspb.Message.getRepeatedField(msg, 46)) == null ? undefined : f,
    marginType: jspb.Message.getFieldWithDefault(msg, 47, ""),
    externalId: jspb.Message.getFieldWithDefault(msg, 48, ""),
    masterReference: jspb.Message.getFieldWithDefault(msg, 49, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.reportpb.ListActivityRequest}
 */
proto.reportpb.ListActivityRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.reportpb.ListActivityRequest;
  return proto.reportpb.ListActivityRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.reportpb.ListActivityRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.reportpb.ListActivityRequest}
 */
proto.reportpb.ListActivityRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setCorrespondent(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setAccountNo(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setContraAccountNo(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setMasterAccountNo(value);
      break;
    case 5:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setAsoftrns(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setBroker(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.setType(value);
      break;
    case 8:
      var value = /** @type {string} */ (reader.readString());
      msg.setSymbol(value);
      break;
    case 9:
      var value = /** @type {string} */ (reader.readString());
      msg.setCusip(value);
      break;
    case 10:
      var value = /** @type {string} */ (reader.readString());
      msg.setStatus(value);
      break;
    case 11:
      var value = /** @type {string} */ (reader.readString());
      msg.setDateType(value);
      break;
    case 12:
      var value = new google_type_date_pb.Date;
      reader.readMessage(value,google_type_date_pb.Date.deserializeBinaryFromReader);
      msg.setFromDate(value);
      break;
    case 13:
      var value = new google_type_date_pb.Date;
      reader.readMessage(value,google_type_date_pb.Date.deserializeBinaryFromReader);
      msg.setToDate(value);
      break;
    case 14:
      var value = /** @type {string} */ (reader.readString());
      msg.setEntryType(value);
      break;
    case 15:
      var value = /** @type {string} */ (reader.readString());
      msg.setBranch(value);
      break;
    case 16:
      var value = /** @type {string} */ (reader.readString());
      msg.setRep(value);
      break;
    case 17:
      var value = /** @type {string} */ (reader.readString());
      msg.setSearchType(value);
      break;
    case 18:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setCompressId(value);
      break;
    case 19:
      var value = /** @type {string} */ (reader.readString());
      msg.setSide(value);
      break;
    case 20:
      var value = new proto_utilspb_pagination_pb.Pagination;
      reader.readMessage(value,proto_utilspb_pagination_pb.Pagination.deserializeBinaryFromReader);
      msg.setPagination(value);
      break;
    case 21:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setTrnsId(value);
      break;
    case 22:
      var value = /** @type {string} */ (reader.readString());
      msg.setAssetType(value);
      break;
    case 23:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setAccountId(value);
      break;
    case 24:
      var value = /** @type {string} */ (reader.readString());
      msg.setDescription(value);
      break;
    case 25:
      var value = /** @type {string} */ (reader.readString());
      msg.setReferenceId(value);
      break;
    case 26:
      var value = /** @type {string} */ (reader.readString());
      msg.setParticipantNo(value);
      break;
    case 27:
      var value = /** @type {string} */ (reader.readString());
      msg.setBatchNo(value);
      break;
    case 28:
      var value = /** @type {string} */ (reader.readString());
      msg.setTransactionSide(value);
      break;
    case 29:
      var value = /** @type {string} */ (reader.readString());
      msg.setCurrency(value);
      break;
    case 30:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setQtyOnly(value);
      break;
    case 31:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setNetAmtOnly(value);
      break;
    case 32:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setBreakdownOtherFees(value);
      break;
    case 34:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setSubAccountType(value);
      break;
    case 35:
      var value = /** @type {string} */ (reader.readString());
      msg.setSubAccountNo(value);
      break;
    case 36:
      var value = new google_type_date_pb.Date;
      reader.readMessage(value,google_type_date_pb.Date.deserializeBinaryFromReader);
      msg.setEffTradeDate(value);
      break;
    case 37:
      var value = new google_type_date_pb.Date;
      reader.readMessage(value,google_type_date_pb.Date.deserializeBinaryFromReader);
      msg.setEffSettleDate(value);
      break;
    case 38:
      var value = /** @type {string} */ (reader.readString());
      msg.setCapacity(value);
      break;
    case 39:
      var value = /** @type {string} */ (reader.readString());
      msg.setContraSubAccountNo(value);
      break;
    case 40:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setContraAccountId(value);
      break;
    case 41:
      var value = /** @type {string} */ (reader.readString());
      msg.setOriginalCusip(value);
      break;
    case 42:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setDisableOriginalCusipMapping(value);
      break;
    case 43:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIsReused(value);
      break;
    case 44:
      var value = /** @type {string} */ (reader.readString());
      msg.setDvpExternalId(value);
      break;
    case 45:
      var value = /** @type {string} */ (reader.readString());
      msg.setCreatedBy(value);
      break;
    case 46:
      var values = /** @type {!Array<number>} */ (reader.isDelimited() ? reader.readPackedUint32() : [reader.readUint32()]);
      for (var i = 0; i < values.length; i++) {
        msg.addIncludeTrnsIds(values[i]);
      }
      break;
    case 47:
      var value = /** @type {string} */ (reader.readString());
      msg.setMarginType(value);
      break;
    case 48:
      var value = /** @type {string} */ (reader.readString());
      msg.setExternalId(value);
      break;
    case 49:
      var value = /** @type {string} */ (reader.readString());
      msg.setMasterReference(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.reportpb.ListActivityRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.reportpb.ListActivityRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.reportpb.ListActivityRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.reportpb.ListActivityRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCorrespondent();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getAccountNo();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getContraAccountNo();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getMasterAccountNo();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getAsoftrns();
  if (f) {
    writer.writeBool(
      5,
      f
    );
  }
  f = message.getBroker();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getType();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
  f = message.getSymbol();
  if (f.length > 0) {
    writer.writeString(
      8,
      f
    );
  }
  f = message.getCusip();
  if (f.length > 0) {
    writer.writeString(
      9,
      f
    );
  }
  f = message.getStatus();
  if (f.length > 0) {
    writer.writeString(
      10,
      f
    );
  }
  f = message.getDateType();
  if (f.length > 0) {
    writer.writeString(
      11,
      f
    );
  }
  f = message.getFromDate();
  if (f != null) {
    writer.writeMessage(
      12,
      f,
      google_type_date_pb.Date.serializeBinaryToWriter
    );
  }
  f = message.getToDate();
  if (f != null) {
    writer.writeMessage(
      13,
      f,
      google_type_date_pb.Date.serializeBinaryToWriter
    );
  }
  f = message.getEntryType();
  if (f.length > 0) {
    writer.writeString(
      14,
      f
    );
  }
  f = message.getBranch();
  if (f.length > 0) {
    writer.writeString(
      15,
      f
    );
  }
  f = message.getRep();
  if (f.length > 0) {
    writer.writeString(
      16,
      f
    );
  }
  f = message.getSearchType();
  if (f.length > 0) {
    writer.writeString(
      17,
      f
    );
  }
  f = message.getCompressId();
  if (f !== 0) {
    writer.writeUint32(
      18,
      f
    );
  }
  f = message.getSide();
  if (f.length > 0) {
    writer.writeString(
      19,
      f
    );
  }
  f = message.getPagination();
  if (f != null) {
    writer.writeMessage(
      20,
      f,
      proto_utilspb_pagination_pb.Pagination.serializeBinaryToWriter
    );
  }
  f = message.getTrnsId();
  if (f !== 0) {
    writer.writeUint32(
      21,
      f
    );
  }
  f = message.getAssetType();
  if (f.length > 0) {
    writer.writeString(
      22,
      f
    );
  }
  f = message.getAccountId();
  if (f !== 0) {
    writer.writeUint32(
      23,
      f
    );
  }
  f = message.getDescription();
  if (f.length > 0) {
    writer.writeString(
      24,
      f
    );
  }
  f = message.getReferenceId();
  if (f.length > 0) {
    writer.writeString(
      25,
      f
    );
  }
  f = message.getParticipantNo();
  if (f.length > 0) {
    writer.writeString(
      26,
      f
    );
  }
  f = message.getBatchNo();
  if (f.length > 0) {
    writer.writeString(
      27,
      f
    );
  }
  f = message.getTransactionSide();
  if (f.length > 0) {
    writer.writeString(
      28,
      f
    );
  }
  f = message.getCurrency();
  if (f.length > 0) {
    writer.writeString(
      29,
      f
    );
  }
  f = message.getQtyOnly();
  if (f) {
    writer.writeBool(
      30,
      f
    );
  }
  f = message.getNetAmtOnly();
  if (f) {
    writer.writeBool(
      31,
      f
    );
  }
  f = message.getBreakdownOtherFees();
  if (f) {
    writer.writeBool(
      32,
      f
    );
  }
  f = message.getSubAccountType();
  if (f !== 0) {
    writer.writeUint32(
      34,
      f
    );
  }
  f = message.getSubAccountNo();
  if (f.length > 0) {
    writer.writeString(
      35,
      f
    );
  }
  f = message.getEffTradeDate();
  if (f != null) {
    writer.writeMessage(
      36,
      f,
      google_type_date_pb.Date.serializeBinaryToWriter
    );
  }
  f = message.getEffSettleDate();
  if (f != null) {
    writer.writeMessage(
      37,
      f,
      google_type_date_pb.Date.serializeBinaryToWriter
    );
  }
  f = message.getCapacity();
  if (f.length > 0) {
    writer.writeString(
      38,
      f
    );
  }
  f = message.getContraSubAccountNo();
  if (f.length > 0) {
    writer.writeString(
      39,
      f
    );
  }
  f = message.getContraAccountId();
  if (f !== 0) {
    writer.writeUint32(
      40,
      f
    );
  }
  f = message.getOriginalCusip();
  if (f.length > 0) {
    writer.writeString(
      41,
      f
    );
  }
  f = message.getDisableOriginalCusipMapping();
  if (f) {
    writer.writeBool(
      42,
      f
    );
  }
  f = message.getIsReused();
  if (f) {
    writer.writeBool(
      43,
      f
    );
  }
  f = message.getDvpExternalId();
  if (f.length > 0) {
    writer.writeString(
      44,
      f
    );
  }
  f = message.getCreatedBy();
  if (f.length > 0) {
    writer.writeString(
      45,
      f
    );
  }
  f = message.getIncludeTrnsIdsList();
  if (f.length > 0) {
    writer.writePackedUint32(
      46,
      f
    );
  }
  f = message.getMarginType();
  if (f.length > 0) {
    writer.writeString(
      47,
      f
    );
  }
  f = message.getExternalId();
  if (f.length > 0) {
    writer.writeString(
      48,
      f
    );
  }
  f = message.getMasterReference();
  if (f.length > 0) {
    writer.writeString(
      49,
      f
    );
  }
};


/**
 * optional string correspondent = 1;
 * @return {string}
 */
proto.reportpb.ListActivityRequest.prototype.getCorrespondent = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.reportpb.ListActivityRequest} returns this
 */
proto.reportpb.ListActivityRequest.prototype.setCorrespondent = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string account_no = 2;
 * @return {string}
 */
proto.reportpb.ListActivityRequest.prototype.getAccountNo = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.reportpb.ListActivityRequest} returns this
 */
proto.reportpb.ListActivityRequest.prototype.setAccountNo = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string contra_account_no = 3;
 * @return {string}
 */
proto.reportpb.ListActivityRequest.prototype.getContraAccountNo = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.reportpb.ListActivityRequest} returns this
 */
proto.reportpb.ListActivityRequest.prototype.setContraAccountNo = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string master_account_no = 4;
 * @return {string}
 */
proto.reportpb.ListActivityRequest.prototype.getMasterAccountNo = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.reportpb.ListActivityRequest} returns this
 */
proto.reportpb.ListActivityRequest.prototype.setMasterAccountNo = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional bool asOfTRNS = 5;
 * @return {boolean}
 */
proto.reportpb.ListActivityRequest.prototype.getAsoftrns = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 5, false));
};


/**
 * @param {boolean} value
 * @return {!proto.reportpb.ListActivityRequest} returns this
 */
proto.reportpb.ListActivityRequest.prototype.setAsoftrns = function(value) {
  return jspb.Message.setProto3BooleanField(this, 5, value);
};


/**
 * optional string broker = 6;
 * @return {string}
 */
proto.reportpb.ListActivityRequest.prototype.getBroker = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.reportpb.ListActivityRequest} returns this
 */
proto.reportpb.ListActivityRequest.prototype.setBroker = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * optional string type = 7;
 * @return {string}
 */
proto.reportpb.ListActivityRequest.prototype.getType = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/**
 * @param {string} value
 * @return {!proto.reportpb.ListActivityRequest} returns this
 */
proto.reportpb.ListActivityRequest.prototype.setType = function(value) {
  return jspb.Message.setProto3StringField(this, 7, value);
};


/**
 * optional string symbol = 8;
 * @return {string}
 */
proto.reportpb.ListActivityRequest.prototype.getSymbol = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 8, ""));
};


/**
 * @param {string} value
 * @return {!proto.reportpb.ListActivityRequest} returns this
 */
proto.reportpb.ListActivityRequest.prototype.setSymbol = function(value) {
  return jspb.Message.setProto3StringField(this, 8, value);
};


/**
 * optional string cusip = 9;
 * @return {string}
 */
proto.reportpb.ListActivityRequest.prototype.getCusip = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 9, ""));
};


/**
 * @param {string} value
 * @return {!proto.reportpb.ListActivityRequest} returns this
 */
proto.reportpb.ListActivityRequest.prototype.setCusip = function(value) {
  return jspb.Message.setProto3StringField(this, 9, value);
};


/**
 * optional string status = 10;
 * @return {string}
 */
proto.reportpb.ListActivityRequest.prototype.getStatus = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 10, ""));
};


/**
 * @param {string} value
 * @return {!proto.reportpb.ListActivityRequest} returns this
 */
proto.reportpb.ListActivityRequest.prototype.setStatus = function(value) {
  return jspb.Message.setProto3StringField(this, 10, value);
};


/**
 * optional string date_type = 11;
 * @return {string}
 */
proto.reportpb.ListActivityRequest.prototype.getDateType = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 11, ""));
};


/**
 * @param {string} value
 * @return {!proto.reportpb.ListActivityRequest} returns this
 */
proto.reportpb.ListActivityRequest.prototype.setDateType = function(value) {
  return jspb.Message.setProto3StringField(this, 11, value);
};


/**
 * optional google.type.Date from_date = 12;
 * @return {?proto.google.type.Date}
 */
proto.reportpb.ListActivityRequest.prototype.getFromDate = function() {
  return /** @type{?proto.google.type.Date} */ (
    jspb.Message.getWrapperField(this, google_type_date_pb.Date, 12));
};


/**
 * @param {?proto.google.type.Date|undefined} value
 * @return {!proto.reportpb.ListActivityRequest} returns this
*/
proto.reportpb.ListActivityRequest.prototype.setFromDate = function(value) {
  return jspb.Message.setWrapperField(this, 12, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.reportpb.ListActivityRequest} returns this
 */
proto.reportpb.ListActivityRequest.prototype.clearFromDate = function() {
  return this.setFromDate(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.reportpb.ListActivityRequest.prototype.hasFromDate = function() {
  return jspb.Message.getField(this, 12) != null;
};


/**
 * optional google.type.Date to_date = 13;
 * @return {?proto.google.type.Date}
 */
proto.reportpb.ListActivityRequest.prototype.getToDate = function() {
  return /** @type{?proto.google.type.Date} */ (
    jspb.Message.getWrapperField(this, google_type_date_pb.Date, 13));
};


/**
 * @param {?proto.google.type.Date|undefined} value
 * @return {!proto.reportpb.ListActivityRequest} returns this
*/
proto.reportpb.ListActivityRequest.prototype.setToDate = function(value) {
  return jspb.Message.setWrapperField(this, 13, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.reportpb.ListActivityRequest} returns this
 */
proto.reportpb.ListActivityRequest.prototype.clearToDate = function() {
  return this.setToDate(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.reportpb.ListActivityRequest.prototype.hasToDate = function() {
  return jspb.Message.getField(this, 13) != null;
};


/**
 * optional string entry_type = 14;
 * @return {string}
 */
proto.reportpb.ListActivityRequest.prototype.getEntryType = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 14, ""));
};


/**
 * @param {string} value
 * @return {!proto.reportpb.ListActivityRequest} returns this
 */
proto.reportpb.ListActivityRequest.prototype.setEntryType = function(value) {
  return jspb.Message.setProto3StringField(this, 14, value);
};


/**
 * optional string branch = 15;
 * @return {string}
 */
proto.reportpb.ListActivityRequest.prototype.getBranch = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 15, ""));
};


/**
 * @param {string} value
 * @return {!proto.reportpb.ListActivityRequest} returns this
 */
proto.reportpb.ListActivityRequest.prototype.setBranch = function(value) {
  return jspb.Message.setProto3StringField(this, 15, value);
};


/**
 * optional string rep = 16;
 * @return {string}
 */
proto.reportpb.ListActivityRequest.prototype.getRep = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 16, ""));
};


/**
 * @param {string} value
 * @return {!proto.reportpb.ListActivityRequest} returns this
 */
proto.reportpb.ListActivityRequest.prototype.setRep = function(value) {
  return jspb.Message.setProto3StringField(this, 16, value);
};


/**
 * optional string search_type = 17;
 * @return {string}
 */
proto.reportpb.ListActivityRequest.prototype.getSearchType = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 17, ""));
};


/**
 * @param {string} value
 * @return {!proto.reportpb.ListActivityRequest} returns this
 */
proto.reportpb.ListActivityRequest.prototype.setSearchType = function(value) {
  return jspb.Message.setProto3StringField(this, 17, value);
};


/**
 * optional uint32 compress_id = 18;
 * @return {number}
 */
proto.reportpb.ListActivityRequest.prototype.getCompressId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 18, 0));
};


/**
 * @param {number} value
 * @return {!proto.reportpb.ListActivityRequest} returns this
 */
proto.reportpb.ListActivityRequest.prototype.setCompressId = function(value) {
  return jspb.Message.setProto3IntField(this, 18, value);
};


/**
 * optional string side = 19;
 * @return {string}
 */
proto.reportpb.ListActivityRequest.prototype.getSide = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 19, ""));
};


/**
 * @param {string} value
 * @return {!proto.reportpb.ListActivityRequest} returns this
 */
proto.reportpb.ListActivityRequest.prototype.setSide = function(value) {
  return jspb.Message.setProto3StringField(this, 19, value);
};


/**
 * optional utilspb.Pagination pagination = 20;
 * @return {?proto.utilspb.Pagination}
 */
proto.reportpb.ListActivityRequest.prototype.getPagination = function() {
  return /** @type{?proto.utilspb.Pagination} */ (
    jspb.Message.getWrapperField(this, proto_utilspb_pagination_pb.Pagination, 20));
};


/**
 * @param {?proto.utilspb.Pagination|undefined} value
 * @return {!proto.reportpb.ListActivityRequest} returns this
*/
proto.reportpb.ListActivityRequest.prototype.setPagination = function(value) {
  return jspb.Message.setWrapperField(this, 20, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.reportpb.ListActivityRequest} returns this
 */
proto.reportpb.ListActivityRequest.prototype.clearPagination = function() {
  return this.setPagination(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.reportpb.ListActivityRequest.prototype.hasPagination = function() {
  return jspb.Message.getField(this, 20) != null;
};


/**
 * optional uint32 trns_id = 21;
 * @return {number}
 */
proto.reportpb.ListActivityRequest.prototype.getTrnsId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 21, 0));
};


/**
 * @param {number} value
 * @return {!proto.reportpb.ListActivityRequest} returns this
 */
proto.reportpb.ListActivityRequest.prototype.setTrnsId = function(value) {
  return jspb.Message.setProto3IntField(this, 21, value);
};


/**
 * optional string asset_type = 22;
 * @return {string}
 */
proto.reportpb.ListActivityRequest.prototype.getAssetType = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 22, ""));
};


/**
 * @param {string} value
 * @return {!proto.reportpb.ListActivityRequest} returns this
 */
proto.reportpb.ListActivityRequest.prototype.setAssetType = function(value) {
  return jspb.Message.setProto3StringField(this, 22, value);
};


/**
 * optional uint32 account_id = 23;
 * @return {number}
 */
proto.reportpb.ListActivityRequest.prototype.getAccountId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 23, 0));
};


/**
 * @param {number} value
 * @return {!proto.reportpb.ListActivityRequest} returns this
 */
proto.reportpb.ListActivityRequest.prototype.setAccountId = function(value) {
  return jspb.Message.setProto3IntField(this, 23, value);
};


/**
 * optional string description = 24;
 * @return {string}
 */
proto.reportpb.ListActivityRequest.prototype.getDescription = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 24, ""));
};


/**
 * @param {string} value
 * @return {!proto.reportpb.ListActivityRequest} returns this
 */
proto.reportpb.ListActivityRequest.prototype.setDescription = function(value) {
  return jspb.Message.setProto3StringField(this, 24, value);
};


/**
 * optional string reference_id = 25;
 * @return {string}
 */
proto.reportpb.ListActivityRequest.prototype.getReferenceId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 25, ""));
};


/**
 * @param {string} value
 * @return {!proto.reportpb.ListActivityRequest} returns this
 */
proto.reportpb.ListActivityRequest.prototype.setReferenceId = function(value) {
  return jspb.Message.setProto3StringField(this, 25, value);
};


/**
 * optional string participant_no = 26;
 * @return {string}
 */
proto.reportpb.ListActivityRequest.prototype.getParticipantNo = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 26, ""));
};


/**
 * @param {string} value
 * @return {!proto.reportpb.ListActivityRequest} returns this
 */
proto.reportpb.ListActivityRequest.prototype.setParticipantNo = function(value) {
  return jspb.Message.setProto3StringField(this, 26, value);
};


/**
 * optional string batch_no = 27;
 * @return {string}
 */
proto.reportpb.ListActivityRequest.prototype.getBatchNo = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 27, ""));
};


/**
 * @param {string} value
 * @return {!proto.reportpb.ListActivityRequest} returns this
 */
proto.reportpb.ListActivityRequest.prototype.setBatchNo = function(value) {
  return jspb.Message.setProto3StringField(this, 27, value);
};


/**
 * optional string transaction_side = 28;
 * @return {string}
 */
proto.reportpb.ListActivityRequest.prototype.getTransactionSide = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 28, ""));
};


/**
 * @param {string} value
 * @return {!proto.reportpb.ListActivityRequest} returns this
 */
proto.reportpb.ListActivityRequest.prototype.setTransactionSide = function(value) {
  return jspb.Message.setProto3StringField(this, 28, value);
};


/**
 * optional string currency = 29;
 * @return {string}
 */
proto.reportpb.ListActivityRequest.prototype.getCurrency = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 29, ""));
};


/**
 * @param {string} value
 * @return {!proto.reportpb.ListActivityRequest} returns this
 */
proto.reportpb.ListActivityRequest.prototype.setCurrency = function(value) {
  return jspb.Message.setProto3StringField(this, 29, value);
};


/**
 * optional bool qty_only = 30;
 * @return {boolean}
 */
proto.reportpb.ListActivityRequest.prototype.getQtyOnly = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 30, false));
};


/**
 * @param {boolean} value
 * @return {!proto.reportpb.ListActivityRequest} returns this
 */
proto.reportpb.ListActivityRequest.prototype.setQtyOnly = function(value) {
  return jspb.Message.setProto3BooleanField(this, 30, value);
};


/**
 * optional bool net_amt_only = 31;
 * @return {boolean}
 */
proto.reportpb.ListActivityRequest.prototype.getNetAmtOnly = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 31, false));
};


/**
 * @param {boolean} value
 * @return {!proto.reportpb.ListActivityRequest} returns this
 */
proto.reportpb.ListActivityRequest.prototype.setNetAmtOnly = function(value) {
  return jspb.Message.setProto3BooleanField(this, 31, value);
};


/**
 * optional bool breakdown_other_fees = 32;
 * @return {boolean}
 */
proto.reportpb.ListActivityRequest.prototype.getBreakdownOtherFees = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 32, false));
};


/**
 * @param {boolean} value
 * @return {!proto.reportpb.ListActivityRequest} returns this
 */
proto.reportpb.ListActivityRequest.prototype.setBreakdownOtherFees = function(value) {
  return jspb.Message.setProto3BooleanField(this, 32, value);
};


/**
 * optional uint32 sub_account_type = 34;
 * @return {number}
 */
proto.reportpb.ListActivityRequest.prototype.getSubAccountType = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 34, 0));
};


/**
 * @param {number} value
 * @return {!proto.reportpb.ListActivityRequest} returns this
 */
proto.reportpb.ListActivityRequest.prototype.setSubAccountType = function(value) {
  return jspb.Message.setProto3IntField(this, 34, value);
};


/**
 * optional string sub_account_no = 35;
 * @return {string}
 */
proto.reportpb.ListActivityRequest.prototype.getSubAccountNo = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 35, ""));
};


/**
 * @param {string} value
 * @return {!proto.reportpb.ListActivityRequest} returns this
 */
proto.reportpb.ListActivityRequest.prototype.setSubAccountNo = function(value) {
  return jspb.Message.setProto3StringField(this, 35, value);
};


/**
 * optional google.type.Date eff_trade_date = 36;
 * @return {?proto.google.type.Date}
 */
proto.reportpb.ListActivityRequest.prototype.getEffTradeDate = function() {
  return /** @type{?proto.google.type.Date} */ (
    jspb.Message.getWrapperField(this, google_type_date_pb.Date, 36));
};


/**
 * @param {?proto.google.type.Date|undefined} value
 * @return {!proto.reportpb.ListActivityRequest} returns this
*/
proto.reportpb.ListActivityRequest.prototype.setEffTradeDate = function(value) {
  return jspb.Message.setWrapperField(this, 36, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.reportpb.ListActivityRequest} returns this
 */
proto.reportpb.ListActivityRequest.prototype.clearEffTradeDate = function() {
  return this.setEffTradeDate(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.reportpb.ListActivityRequest.prototype.hasEffTradeDate = function() {
  return jspb.Message.getField(this, 36) != null;
};


/**
 * optional google.type.Date eff_settle_date = 37;
 * @return {?proto.google.type.Date}
 */
proto.reportpb.ListActivityRequest.prototype.getEffSettleDate = function() {
  return /** @type{?proto.google.type.Date} */ (
    jspb.Message.getWrapperField(this, google_type_date_pb.Date, 37));
};


/**
 * @param {?proto.google.type.Date|undefined} value
 * @return {!proto.reportpb.ListActivityRequest} returns this
*/
proto.reportpb.ListActivityRequest.prototype.setEffSettleDate = function(value) {
  return jspb.Message.setWrapperField(this, 37, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.reportpb.ListActivityRequest} returns this
 */
proto.reportpb.ListActivityRequest.prototype.clearEffSettleDate = function() {
  return this.setEffSettleDate(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.reportpb.ListActivityRequest.prototype.hasEffSettleDate = function() {
  return jspb.Message.getField(this, 37) != null;
};


/**
 * optional string capacity = 38;
 * @return {string}
 */
proto.reportpb.ListActivityRequest.prototype.getCapacity = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 38, ""));
};


/**
 * @param {string} value
 * @return {!proto.reportpb.ListActivityRequest} returns this
 */
proto.reportpb.ListActivityRequest.prototype.setCapacity = function(value) {
  return jspb.Message.setProto3StringField(this, 38, value);
};


/**
 * optional string contra_sub_account_no = 39;
 * @return {string}
 */
proto.reportpb.ListActivityRequest.prototype.getContraSubAccountNo = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 39, ""));
};


/**
 * @param {string} value
 * @return {!proto.reportpb.ListActivityRequest} returns this
 */
proto.reportpb.ListActivityRequest.prototype.setContraSubAccountNo = function(value) {
  return jspb.Message.setProto3StringField(this, 39, value);
};


/**
 * optional uint32 contra_account_id = 40;
 * @return {number}
 */
proto.reportpb.ListActivityRequest.prototype.getContraAccountId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 40, 0));
};


/**
 * @param {number} value
 * @return {!proto.reportpb.ListActivityRequest} returns this
 */
proto.reportpb.ListActivityRequest.prototype.setContraAccountId = function(value) {
  return jspb.Message.setProto3IntField(this, 40, value);
};


/**
 * optional string original_cusip = 41;
 * @return {string}
 */
proto.reportpb.ListActivityRequest.prototype.getOriginalCusip = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 41, ""));
};


/**
 * @param {string} value
 * @return {!proto.reportpb.ListActivityRequest} returns this
 */
proto.reportpb.ListActivityRequest.prototype.setOriginalCusip = function(value) {
  return jspb.Message.setProto3StringField(this, 41, value);
};


/**
 * optional bool disable_original_cusip_mapping = 42;
 * @return {boolean}
 */
proto.reportpb.ListActivityRequest.prototype.getDisableOriginalCusipMapping = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 42, false));
};


/**
 * @param {boolean} value
 * @return {!proto.reportpb.ListActivityRequest} returns this
 */
proto.reportpb.ListActivityRequest.prototype.setDisableOriginalCusipMapping = function(value) {
  return jspb.Message.setProto3BooleanField(this, 42, value);
};


/**
 * optional bool is_reused = 43;
 * @return {boolean}
 */
proto.reportpb.ListActivityRequest.prototype.getIsReused = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 43, false));
};


/**
 * @param {boolean} value
 * @return {!proto.reportpb.ListActivityRequest} returns this
 */
proto.reportpb.ListActivityRequest.prototype.setIsReused = function(value) {
  return jspb.Message.setProto3BooleanField(this, 43, value);
};


/**
 * optional string dvp_external_id = 44;
 * @return {string}
 */
proto.reportpb.ListActivityRequest.prototype.getDvpExternalId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 44, ""));
};


/**
 * @param {string} value
 * @return {!proto.reportpb.ListActivityRequest} returns this
 */
proto.reportpb.ListActivityRequest.prototype.setDvpExternalId = function(value) {
  return jspb.Message.setProto3StringField(this, 44, value);
};


/**
 * optional string created_by = 45;
 * @return {string}
 */
proto.reportpb.ListActivityRequest.prototype.getCreatedBy = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 45, ""));
};


/**
 * @param {string} value
 * @return {!proto.reportpb.ListActivityRequest} returns this
 */
proto.reportpb.ListActivityRequest.prototype.setCreatedBy = function(value) {
  return jspb.Message.setProto3StringField(this, 45, value);
};


/**
 * repeated uint32 include_trns_ids = 46;
 * @return {!Array<number>}
 */
proto.reportpb.ListActivityRequest.prototype.getIncludeTrnsIdsList = function() {
  return /** @type {!Array<number>} */ (jspb.Message.getRepeatedField(this, 46));
};


/**
 * @param {!Array<number>} value
 * @return {!proto.reportpb.ListActivityRequest} returns this
 */
proto.reportpb.ListActivityRequest.prototype.setIncludeTrnsIdsList = function(value) {
  return jspb.Message.setField(this, 46, value || []);
};


/**
 * @param {number} value
 * @param {number=} opt_index
 * @return {!proto.reportpb.ListActivityRequest} returns this
 */
proto.reportpb.ListActivityRequest.prototype.addIncludeTrnsIds = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 46, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.reportpb.ListActivityRequest} returns this
 */
proto.reportpb.ListActivityRequest.prototype.clearIncludeTrnsIdsList = function() {
  return this.setIncludeTrnsIdsList([]);
};


/**
 * optional string margin_type = 47;
 * @return {string}
 */
proto.reportpb.ListActivityRequest.prototype.getMarginType = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 47, ""));
};


/**
 * @param {string} value
 * @return {!proto.reportpb.ListActivityRequest} returns this
 */
proto.reportpb.ListActivityRequest.prototype.setMarginType = function(value) {
  return jspb.Message.setProto3StringField(this, 47, value);
};


/**
 * optional string external_id = 48;
 * @return {string}
 */
proto.reportpb.ListActivityRequest.prototype.getExternalId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 48, ""));
};


/**
 * @param {string} value
 * @return {!proto.reportpb.ListActivityRequest} returns this
 */
proto.reportpb.ListActivityRequest.prototype.setExternalId = function(value) {
  return jspb.Message.setProto3StringField(this, 48, value);
};


/**
 * optional string master_reference = 49;
 * @return {string}
 */
proto.reportpb.ListActivityRequest.prototype.getMasterReference = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 49, ""));
};


/**
 * @param {string} value
 * @return {!proto.reportpb.ListActivityRequest} returns this
 */
proto.reportpb.ListActivityRequest.prototype.setMasterReference = function(value) {
  return jspb.Message.setProto3StringField(this, 49, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.reportpb.PageViewActivityRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.reportpb.PageViewActivityRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.reportpb.PageViewActivityRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.reportpb.PageViewActivityRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    pagination: (f = msg.getPagination()) && proto_utilspb_pagination_pb.Pagination.toObject(includeInstance, f),
    dateType: jspb.Message.getFieldWithDefault(msg, 2, ""),
    fromDate: (f = msg.getFromDate()) && google_type_date_pb.Date.toObject(includeInstance, f),
    toDate: (f = msg.getToDate()) && google_type_date_pb.Date.toObject(includeInstance, f),
    correspondent: jspb.Message.getFieldWithDefault(msg, 5, ""),
    accountNo: jspb.Message.getFieldWithDefault(msg, 6, ""),
    masterAccountNo: jspb.Message.getFieldWithDefault(msg, 7, ""),
    branch: jspb.Message.getFieldWithDefault(msg, 8, ""),
    rep: jspb.Message.getFieldWithDefault(msg, 9, ""),
    contraAccountNo: jspb.Message.getFieldWithDefault(msg, 10, ""),
    broker: jspb.Message.getFieldWithDefault(msg, 11, ""),
    type: jspb.Message.getFieldWithDefault(msg, 12, ""),
    symbol: jspb.Message.getFieldWithDefault(msg, 13, ""),
    cusip: jspb.Message.getFieldWithDefault(msg, 14, ""),
    status: jspb.Message.getFieldWithDefault(msg, 15, ""),
    entryType: jspb.Message.getFieldWithDefault(msg, 16, ""),
    side: jspb.Message.getFieldWithDefault(msg, 17, ""),
    assetType: jspb.Message.getFieldWithDefault(msg, 18, ""),
    trnsId: jspb.Message.getFieldWithDefault(msg, 19, 0),
    asoftrns: jspb.Message.getBooleanFieldWithDefault(msg, 20, false),
    searchType: jspb.Message.getFieldWithDefault(msg, 21, ""),
    description: jspb.Message.getFieldWithDefault(msg, 22, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.reportpb.PageViewActivityRequest}
 */
proto.reportpb.PageViewActivityRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.reportpb.PageViewActivityRequest;
  return proto.reportpb.PageViewActivityRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.reportpb.PageViewActivityRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.reportpb.PageViewActivityRequest}
 */
proto.reportpb.PageViewActivityRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto_utilspb_pagination_pb.Pagination;
      reader.readMessage(value,proto_utilspb_pagination_pb.Pagination.deserializeBinaryFromReader);
      msg.setPagination(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setDateType(value);
      break;
    case 3:
      var value = new google_type_date_pb.Date;
      reader.readMessage(value,google_type_date_pb.Date.deserializeBinaryFromReader);
      msg.setFromDate(value);
      break;
    case 4:
      var value = new google_type_date_pb.Date;
      reader.readMessage(value,google_type_date_pb.Date.deserializeBinaryFromReader);
      msg.setToDate(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setCorrespondent(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setAccountNo(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.setMasterAccountNo(value);
      break;
    case 8:
      var value = /** @type {string} */ (reader.readString());
      msg.setBranch(value);
      break;
    case 9:
      var value = /** @type {string} */ (reader.readString());
      msg.setRep(value);
      break;
    case 10:
      var value = /** @type {string} */ (reader.readString());
      msg.setContraAccountNo(value);
      break;
    case 11:
      var value = /** @type {string} */ (reader.readString());
      msg.setBroker(value);
      break;
    case 12:
      var value = /** @type {string} */ (reader.readString());
      msg.setType(value);
      break;
    case 13:
      var value = /** @type {string} */ (reader.readString());
      msg.setSymbol(value);
      break;
    case 14:
      var value = /** @type {string} */ (reader.readString());
      msg.setCusip(value);
      break;
    case 15:
      var value = /** @type {string} */ (reader.readString());
      msg.setStatus(value);
      break;
    case 16:
      var value = /** @type {string} */ (reader.readString());
      msg.setEntryType(value);
      break;
    case 17:
      var value = /** @type {string} */ (reader.readString());
      msg.setSide(value);
      break;
    case 18:
      var value = /** @type {string} */ (reader.readString());
      msg.setAssetType(value);
      break;
    case 19:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setTrnsId(value);
      break;
    case 20:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setAsoftrns(value);
      break;
    case 21:
      var value = /** @type {string} */ (reader.readString());
      msg.setSearchType(value);
      break;
    case 22:
      var value = /** @type {string} */ (reader.readString());
      msg.setDescription(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.reportpb.PageViewActivityRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.reportpb.PageViewActivityRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.reportpb.PageViewActivityRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.reportpb.PageViewActivityRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getPagination();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto_utilspb_pagination_pb.Pagination.serializeBinaryToWriter
    );
  }
  f = message.getDateType();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getFromDate();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      google_type_date_pb.Date.serializeBinaryToWriter
    );
  }
  f = message.getToDate();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      google_type_date_pb.Date.serializeBinaryToWriter
    );
  }
  f = message.getCorrespondent();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getAccountNo();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getMasterAccountNo();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
  f = message.getBranch();
  if (f.length > 0) {
    writer.writeString(
      8,
      f
    );
  }
  f = message.getRep();
  if (f.length > 0) {
    writer.writeString(
      9,
      f
    );
  }
  f = message.getContraAccountNo();
  if (f.length > 0) {
    writer.writeString(
      10,
      f
    );
  }
  f = message.getBroker();
  if (f.length > 0) {
    writer.writeString(
      11,
      f
    );
  }
  f = message.getType();
  if (f.length > 0) {
    writer.writeString(
      12,
      f
    );
  }
  f = message.getSymbol();
  if (f.length > 0) {
    writer.writeString(
      13,
      f
    );
  }
  f = message.getCusip();
  if (f.length > 0) {
    writer.writeString(
      14,
      f
    );
  }
  f = message.getStatus();
  if (f.length > 0) {
    writer.writeString(
      15,
      f
    );
  }
  f = message.getEntryType();
  if (f.length > 0) {
    writer.writeString(
      16,
      f
    );
  }
  f = message.getSide();
  if (f.length > 0) {
    writer.writeString(
      17,
      f
    );
  }
  f = message.getAssetType();
  if (f.length > 0) {
    writer.writeString(
      18,
      f
    );
  }
  f = message.getTrnsId();
  if (f !== 0) {
    writer.writeUint32(
      19,
      f
    );
  }
  f = message.getAsoftrns();
  if (f) {
    writer.writeBool(
      20,
      f
    );
  }
  f = message.getSearchType();
  if (f.length > 0) {
    writer.writeString(
      21,
      f
    );
  }
  f = message.getDescription();
  if (f.length > 0) {
    writer.writeString(
      22,
      f
    );
  }
};


/**
 * optional utilspb.Pagination pagination = 1;
 * @return {?proto.utilspb.Pagination}
 */
proto.reportpb.PageViewActivityRequest.prototype.getPagination = function() {
  return /** @type{?proto.utilspb.Pagination} */ (
    jspb.Message.getWrapperField(this, proto_utilspb_pagination_pb.Pagination, 1));
};


/**
 * @param {?proto.utilspb.Pagination|undefined} value
 * @return {!proto.reportpb.PageViewActivityRequest} returns this
*/
proto.reportpb.PageViewActivityRequest.prototype.setPagination = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.reportpb.PageViewActivityRequest} returns this
 */
proto.reportpb.PageViewActivityRequest.prototype.clearPagination = function() {
  return this.setPagination(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.reportpb.PageViewActivityRequest.prototype.hasPagination = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional string date_type = 2;
 * @return {string}
 */
proto.reportpb.PageViewActivityRequest.prototype.getDateType = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.reportpb.PageViewActivityRequest} returns this
 */
proto.reportpb.PageViewActivityRequest.prototype.setDateType = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional google.type.Date from_date = 3;
 * @return {?proto.google.type.Date}
 */
proto.reportpb.PageViewActivityRequest.prototype.getFromDate = function() {
  return /** @type{?proto.google.type.Date} */ (
    jspb.Message.getWrapperField(this, google_type_date_pb.Date, 3));
};


/**
 * @param {?proto.google.type.Date|undefined} value
 * @return {!proto.reportpb.PageViewActivityRequest} returns this
*/
proto.reportpb.PageViewActivityRequest.prototype.setFromDate = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.reportpb.PageViewActivityRequest} returns this
 */
proto.reportpb.PageViewActivityRequest.prototype.clearFromDate = function() {
  return this.setFromDate(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.reportpb.PageViewActivityRequest.prototype.hasFromDate = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional google.type.Date to_date = 4;
 * @return {?proto.google.type.Date}
 */
proto.reportpb.PageViewActivityRequest.prototype.getToDate = function() {
  return /** @type{?proto.google.type.Date} */ (
    jspb.Message.getWrapperField(this, google_type_date_pb.Date, 4));
};


/**
 * @param {?proto.google.type.Date|undefined} value
 * @return {!proto.reportpb.PageViewActivityRequest} returns this
*/
proto.reportpb.PageViewActivityRequest.prototype.setToDate = function(value) {
  return jspb.Message.setWrapperField(this, 4, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.reportpb.PageViewActivityRequest} returns this
 */
proto.reportpb.PageViewActivityRequest.prototype.clearToDate = function() {
  return this.setToDate(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.reportpb.PageViewActivityRequest.prototype.hasToDate = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * optional string correspondent = 5;
 * @return {string}
 */
proto.reportpb.PageViewActivityRequest.prototype.getCorrespondent = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.reportpb.PageViewActivityRequest} returns this
 */
proto.reportpb.PageViewActivityRequest.prototype.setCorrespondent = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional string account_no = 6;
 * @return {string}
 */
proto.reportpb.PageViewActivityRequest.prototype.getAccountNo = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.reportpb.PageViewActivityRequest} returns this
 */
proto.reportpb.PageViewActivityRequest.prototype.setAccountNo = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * optional string master_account_no = 7;
 * @return {string}
 */
proto.reportpb.PageViewActivityRequest.prototype.getMasterAccountNo = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/**
 * @param {string} value
 * @return {!proto.reportpb.PageViewActivityRequest} returns this
 */
proto.reportpb.PageViewActivityRequest.prototype.setMasterAccountNo = function(value) {
  return jspb.Message.setProto3StringField(this, 7, value);
};


/**
 * optional string branch = 8;
 * @return {string}
 */
proto.reportpb.PageViewActivityRequest.prototype.getBranch = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 8, ""));
};


/**
 * @param {string} value
 * @return {!proto.reportpb.PageViewActivityRequest} returns this
 */
proto.reportpb.PageViewActivityRequest.prototype.setBranch = function(value) {
  return jspb.Message.setProto3StringField(this, 8, value);
};


/**
 * optional string rep = 9;
 * @return {string}
 */
proto.reportpb.PageViewActivityRequest.prototype.getRep = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 9, ""));
};


/**
 * @param {string} value
 * @return {!proto.reportpb.PageViewActivityRequest} returns this
 */
proto.reportpb.PageViewActivityRequest.prototype.setRep = function(value) {
  return jspb.Message.setProto3StringField(this, 9, value);
};


/**
 * optional string contra_account_no = 10;
 * @return {string}
 */
proto.reportpb.PageViewActivityRequest.prototype.getContraAccountNo = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 10, ""));
};


/**
 * @param {string} value
 * @return {!proto.reportpb.PageViewActivityRequest} returns this
 */
proto.reportpb.PageViewActivityRequest.prototype.setContraAccountNo = function(value) {
  return jspb.Message.setProto3StringField(this, 10, value);
};


/**
 * optional string broker = 11;
 * @return {string}
 */
proto.reportpb.PageViewActivityRequest.prototype.getBroker = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 11, ""));
};


/**
 * @param {string} value
 * @return {!proto.reportpb.PageViewActivityRequest} returns this
 */
proto.reportpb.PageViewActivityRequest.prototype.setBroker = function(value) {
  return jspb.Message.setProto3StringField(this, 11, value);
};


/**
 * optional string type = 12;
 * @return {string}
 */
proto.reportpb.PageViewActivityRequest.prototype.getType = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 12, ""));
};


/**
 * @param {string} value
 * @return {!proto.reportpb.PageViewActivityRequest} returns this
 */
proto.reportpb.PageViewActivityRequest.prototype.setType = function(value) {
  return jspb.Message.setProto3StringField(this, 12, value);
};


/**
 * optional string symbol = 13;
 * @return {string}
 */
proto.reportpb.PageViewActivityRequest.prototype.getSymbol = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 13, ""));
};


/**
 * @param {string} value
 * @return {!proto.reportpb.PageViewActivityRequest} returns this
 */
proto.reportpb.PageViewActivityRequest.prototype.setSymbol = function(value) {
  return jspb.Message.setProto3StringField(this, 13, value);
};


/**
 * optional string cusip = 14;
 * @return {string}
 */
proto.reportpb.PageViewActivityRequest.prototype.getCusip = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 14, ""));
};


/**
 * @param {string} value
 * @return {!proto.reportpb.PageViewActivityRequest} returns this
 */
proto.reportpb.PageViewActivityRequest.prototype.setCusip = function(value) {
  return jspb.Message.setProto3StringField(this, 14, value);
};


/**
 * optional string status = 15;
 * @return {string}
 */
proto.reportpb.PageViewActivityRequest.prototype.getStatus = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 15, ""));
};


/**
 * @param {string} value
 * @return {!proto.reportpb.PageViewActivityRequest} returns this
 */
proto.reportpb.PageViewActivityRequest.prototype.setStatus = function(value) {
  return jspb.Message.setProto3StringField(this, 15, value);
};


/**
 * optional string entry_type = 16;
 * @return {string}
 */
proto.reportpb.PageViewActivityRequest.prototype.getEntryType = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 16, ""));
};


/**
 * @param {string} value
 * @return {!proto.reportpb.PageViewActivityRequest} returns this
 */
proto.reportpb.PageViewActivityRequest.prototype.setEntryType = function(value) {
  return jspb.Message.setProto3StringField(this, 16, value);
};


/**
 * optional string side = 17;
 * @return {string}
 */
proto.reportpb.PageViewActivityRequest.prototype.getSide = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 17, ""));
};


/**
 * @param {string} value
 * @return {!proto.reportpb.PageViewActivityRequest} returns this
 */
proto.reportpb.PageViewActivityRequest.prototype.setSide = function(value) {
  return jspb.Message.setProto3StringField(this, 17, value);
};


/**
 * optional string asset_type = 18;
 * @return {string}
 */
proto.reportpb.PageViewActivityRequest.prototype.getAssetType = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 18, ""));
};


/**
 * @param {string} value
 * @return {!proto.reportpb.PageViewActivityRequest} returns this
 */
proto.reportpb.PageViewActivityRequest.prototype.setAssetType = function(value) {
  return jspb.Message.setProto3StringField(this, 18, value);
};


/**
 * optional uint32 trns_id = 19;
 * @return {number}
 */
proto.reportpb.PageViewActivityRequest.prototype.getTrnsId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 19, 0));
};


/**
 * @param {number} value
 * @return {!proto.reportpb.PageViewActivityRequest} returns this
 */
proto.reportpb.PageViewActivityRequest.prototype.setTrnsId = function(value) {
  return jspb.Message.setProto3IntField(this, 19, value);
};


/**
 * optional bool asOfTRNS = 20;
 * @return {boolean}
 */
proto.reportpb.PageViewActivityRequest.prototype.getAsoftrns = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 20, false));
};


/**
 * @param {boolean} value
 * @return {!proto.reportpb.PageViewActivityRequest} returns this
 */
proto.reportpb.PageViewActivityRequest.prototype.setAsoftrns = function(value) {
  return jspb.Message.setProto3BooleanField(this, 20, value);
};


/**
 * optional string search_type = 21;
 * @return {string}
 */
proto.reportpb.PageViewActivityRequest.prototype.getSearchType = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 21, ""));
};


/**
 * @param {string} value
 * @return {!proto.reportpb.PageViewActivityRequest} returns this
 */
proto.reportpb.PageViewActivityRequest.prototype.setSearchType = function(value) {
  return jspb.Message.setProto3StringField(this, 21, value);
};


/**
 * optional string description = 22;
 * @return {string}
 */
proto.reportpb.PageViewActivityRequest.prototype.getDescription = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 22, ""));
};


/**
 * @param {string} value
 * @return {!proto.reportpb.PageViewActivityRequest} returns this
 */
proto.reportpb.PageViewActivityRequest.prototype.setDescription = function(value) {
  return jspb.Message.setProto3StringField(this, 22, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.reportpb.ListActivityResponse.repeatedFields_ = [1,3];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.reportpb.ListActivityResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.reportpb.ListActivityResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.reportpb.ListActivityResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.reportpb.ListActivityResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    activitiesList: jspb.Message.toObjectList(msg.getActivitiesList(),
    proto.reportpb.Activity.toObject, includeInstance),
    summary: (f = msg.getSummary()) && proto.reportpb.ListActivitySummary.toObject(includeInstance, f),
    otherFeeTypesList: (f = jspb.Message.getRepeatedField(msg, 3)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.reportpb.ListActivityResponse}
 */
proto.reportpb.ListActivityResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.reportpb.ListActivityResponse;
  return proto.reportpb.ListActivityResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.reportpb.ListActivityResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.reportpb.ListActivityResponse}
 */
proto.reportpb.ListActivityResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.reportpb.Activity;
      reader.readMessage(value,proto.reportpb.Activity.deserializeBinaryFromReader);
      msg.addActivities(value);
      break;
    case 2:
      var value = new proto.reportpb.ListActivitySummary;
      reader.readMessage(value,proto.reportpb.ListActivitySummary.deserializeBinaryFromReader);
      msg.setSummary(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.addOtherFeeTypes(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.reportpb.ListActivityResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.reportpb.ListActivityResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.reportpb.ListActivityResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.reportpb.ListActivityResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getActivitiesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.reportpb.Activity.serializeBinaryToWriter
    );
  }
  f = message.getSummary();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.reportpb.ListActivitySummary.serializeBinaryToWriter
    );
  }
  f = message.getOtherFeeTypesList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      3,
      f
    );
  }
};


/**
 * repeated Activity activities = 1;
 * @return {!Array<!proto.reportpb.Activity>}
 */
proto.reportpb.ListActivityResponse.prototype.getActivitiesList = function() {
  return /** @type{!Array<!proto.reportpb.Activity>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.reportpb.Activity, 1));
};


/**
 * @param {!Array<!proto.reportpb.Activity>} value
 * @return {!proto.reportpb.ListActivityResponse} returns this
*/
proto.reportpb.ListActivityResponse.prototype.setActivitiesList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.reportpb.Activity=} opt_value
 * @param {number=} opt_index
 * @return {!proto.reportpb.Activity}
 */
proto.reportpb.ListActivityResponse.prototype.addActivities = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.reportpb.Activity, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.reportpb.ListActivityResponse} returns this
 */
proto.reportpb.ListActivityResponse.prototype.clearActivitiesList = function() {
  return this.setActivitiesList([]);
};


/**
 * optional ListActivitySummary summary = 2;
 * @return {?proto.reportpb.ListActivitySummary}
 */
proto.reportpb.ListActivityResponse.prototype.getSummary = function() {
  return /** @type{?proto.reportpb.ListActivitySummary} */ (
    jspb.Message.getWrapperField(this, proto.reportpb.ListActivitySummary, 2));
};


/**
 * @param {?proto.reportpb.ListActivitySummary|undefined} value
 * @return {!proto.reportpb.ListActivityResponse} returns this
*/
proto.reportpb.ListActivityResponse.prototype.setSummary = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.reportpb.ListActivityResponse} returns this
 */
proto.reportpb.ListActivityResponse.prototype.clearSummary = function() {
  return this.setSummary(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.reportpb.ListActivityResponse.prototype.hasSummary = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * repeated string other_fee_types = 3;
 * @return {!Array<string>}
 */
proto.reportpb.ListActivityResponse.prototype.getOtherFeeTypesList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 3));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.reportpb.ListActivityResponse} returns this
 */
proto.reportpb.ListActivityResponse.prototype.setOtherFeeTypesList = function(value) {
  return jspb.Message.setField(this, 3, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.reportpb.ListActivityResponse} returns this
 */
proto.reportpb.ListActivityResponse.prototype.addOtherFeeTypes = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 3, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.reportpb.ListActivityResponse} returns this
 */
proto.reportpb.ListActivityResponse.prototype.clearOtherFeeTypesList = function() {
  return this.setOtherFeeTypesList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.reportpb.DownloadTradeConfirmationRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.reportpb.DownloadTradeConfirmationRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.reportpb.DownloadTradeConfirmationRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.reportpb.DownloadTradeConfirmationRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    trnsId: jspb.Message.getFieldWithDefault(msg, 1, 0),
    correspondent: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.reportpb.DownloadTradeConfirmationRequest}
 */
proto.reportpb.DownloadTradeConfirmationRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.reportpb.DownloadTradeConfirmationRequest;
  return proto.reportpb.DownloadTradeConfirmationRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.reportpb.DownloadTradeConfirmationRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.reportpb.DownloadTradeConfirmationRequest}
 */
proto.reportpb.DownloadTradeConfirmationRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setTrnsId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setCorrespondent(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.reportpb.DownloadTradeConfirmationRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.reportpb.DownloadTradeConfirmationRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.reportpb.DownloadTradeConfirmationRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.reportpb.DownloadTradeConfirmationRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTrnsId();
  if (f !== 0) {
    writer.writeUint32(
      1,
      f
    );
  }
  f = message.getCorrespondent();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional uint32 trns_id = 1;
 * @return {number}
 */
proto.reportpb.DownloadTradeConfirmationRequest.prototype.getTrnsId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.reportpb.DownloadTradeConfirmationRequest} returns this
 */
proto.reportpb.DownloadTradeConfirmationRequest.prototype.setTrnsId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional string correspondent = 2;
 * @return {string}
 */
proto.reportpb.DownloadTradeConfirmationRequest.prototype.getCorrespondent = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.reportpb.DownloadTradeConfirmationRequest} returns this
 */
proto.reportpb.DownloadTradeConfirmationRequest.prototype.setCorrespondent = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.reportpb.ListActivitySummary.repeatedFields_ = [11,12];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.reportpb.ListActivitySummary.prototype.toObject = function(opt_includeInstance) {
  return proto.reportpb.ListActivitySummary.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.reportpb.ListActivitySummary} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.reportpb.ListActivitySummary.toObject = function(includeInstance, msg) {
  var f, obj = {
    totalRows: jspb.Message.getFieldWithDefault(msg, 1, 0),
    qty: jspb.Message.getFieldWithDefault(msg, 2, ""),
    grossAmt: jspb.Message.getFieldWithDefault(msg, 3, ""),
    regFee: jspb.Message.getFieldWithDefault(msg, 4, ""),
    tafFee: jspb.Message.getFieldWithDefault(msg, 5, ""),
    commission: jspb.Message.getFieldWithDefault(msg, 6, ""),
    fees: jspb.Message.getFieldWithDefault(msg, 7, ""),
    netAmt: jspb.Message.getFieldWithDefault(msg, 8, ""),
    otherFees2: jspb.Message.getFieldWithDefault(msg, 9, ""),
    taxWithholding: jspb.Message.getFieldWithDefault(msg, 10, ""),
    otherFeeTypesList: (f = jspb.Message.getRepeatedField(msg, 11)) == null ? undefined : f,
    otherFeeValuesList: (f = jspb.Message.getRepeatedField(msg, 12)) == null ? undefined : f,
    executionQty: jspb.Message.getFieldWithDefault(msg, 13, ""),
    executionNetAmt: jspb.Message.getFieldWithDefault(msg, 14, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.reportpb.ListActivitySummary}
 */
proto.reportpb.ListActivitySummary.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.reportpb.ListActivitySummary;
  return proto.reportpb.ListActivitySummary.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.reportpb.ListActivitySummary} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.reportpb.ListActivitySummary}
 */
proto.reportpb.ListActivitySummary.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setTotalRows(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setQty(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setGrossAmt(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setRegFee(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setTafFee(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setCommission(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.setFees(value);
      break;
    case 8:
      var value = /** @type {string} */ (reader.readString());
      msg.setNetAmt(value);
      break;
    case 9:
      var value = /** @type {string} */ (reader.readString());
      msg.setOtherFees2(value);
      break;
    case 10:
      var value = /** @type {string} */ (reader.readString());
      msg.setTaxWithholding(value);
      break;
    case 11:
      var value = /** @type {string} */ (reader.readString());
      msg.addOtherFeeTypes(value);
      break;
    case 12:
      var value = /** @type {string} */ (reader.readString());
      msg.addOtherFeeValues(value);
      break;
    case 13:
      var value = /** @type {string} */ (reader.readString());
      msg.setExecutionQty(value);
      break;
    case 14:
      var value = /** @type {string} */ (reader.readString());
      msg.setExecutionNetAmt(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.reportpb.ListActivitySummary.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.reportpb.ListActivitySummary.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.reportpb.ListActivitySummary} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.reportpb.ListActivitySummary.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTotalRows();
  if (f !== 0) {
    writer.writeUint32(
      1,
      f
    );
  }
  f = message.getQty();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getGrossAmt();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getRegFee();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getTafFee();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getCommission();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getFees();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
  f = message.getNetAmt();
  if (f.length > 0) {
    writer.writeString(
      8,
      f
    );
  }
  f = message.getOtherFees2();
  if (f.length > 0) {
    writer.writeString(
      9,
      f
    );
  }
  f = message.getTaxWithholding();
  if (f.length > 0) {
    writer.writeString(
      10,
      f
    );
  }
  f = message.getOtherFeeTypesList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      11,
      f
    );
  }
  f = message.getOtherFeeValuesList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      12,
      f
    );
  }
  f = message.getExecutionQty();
  if (f.length > 0) {
    writer.writeString(
      13,
      f
    );
  }
  f = message.getExecutionNetAmt();
  if (f.length > 0) {
    writer.writeString(
      14,
      f
    );
  }
};


/**
 * optional uint32 total_rows = 1;
 * @return {number}
 */
proto.reportpb.ListActivitySummary.prototype.getTotalRows = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.reportpb.ListActivitySummary} returns this
 */
proto.reportpb.ListActivitySummary.prototype.setTotalRows = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional string qty = 2;
 * @return {string}
 */
proto.reportpb.ListActivitySummary.prototype.getQty = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.reportpb.ListActivitySummary} returns this
 */
proto.reportpb.ListActivitySummary.prototype.setQty = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string gross_amt = 3;
 * @return {string}
 */
proto.reportpb.ListActivitySummary.prototype.getGrossAmt = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.reportpb.ListActivitySummary} returns this
 */
proto.reportpb.ListActivitySummary.prototype.setGrossAmt = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string reg_fee = 4;
 * @return {string}
 */
proto.reportpb.ListActivitySummary.prototype.getRegFee = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.reportpb.ListActivitySummary} returns this
 */
proto.reportpb.ListActivitySummary.prototype.setRegFee = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string taf_fee = 5;
 * @return {string}
 */
proto.reportpb.ListActivitySummary.prototype.getTafFee = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.reportpb.ListActivitySummary} returns this
 */
proto.reportpb.ListActivitySummary.prototype.setTafFee = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional string commission = 6;
 * @return {string}
 */
proto.reportpb.ListActivitySummary.prototype.getCommission = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.reportpb.ListActivitySummary} returns this
 */
proto.reportpb.ListActivitySummary.prototype.setCommission = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * optional string fees = 7;
 * @return {string}
 */
proto.reportpb.ListActivitySummary.prototype.getFees = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/**
 * @param {string} value
 * @return {!proto.reportpb.ListActivitySummary} returns this
 */
proto.reportpb.ListActivitySummary.prototype.setFees = function(value) {
  return jspb.Message.setProto3StringField(this, 7, value);
};


/**
 * optional string net_amt = 8;
 * @return {string}
 */
proto.reportpb.ListActivitySummary.prototype.getNetAmt = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 8, ""));
};


/**
 * @param {string} value
 * @return {!proto.reportpb.ListActivitySummary} returns this
 */
proto.reportpb.ListActivitySummary.prototype.setNetAmt = function(value) {
  return jspb.Message.setProto3StringField(this, 8, value);
};


/**
 * optional string other_fees_2 = 9;
 * @return {string}
 */
proto.reportpb.ListActivitySummary.prototype.getOtherFees2 = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 9, ""));
};


/**
 * @param {string} value
 * @return {!proto.reportpb.ListActivitySummary} returns this
 */
proto.reportpb.ListActivitySummary.prototype.setOtherFees2 = function(value) {
  return jspb.Message.setProto3StringField(this, 9, value);
};


/**
 * optional string tax_withholding = 10;
 * @return {string}
 */
proto.reportpb.ListActivitySummary.prototype.getTaxWithholding = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 10, ""));
};


/**
 * @param {string} value
 * @return {!proto.reportpb.ListActivitySummary} returns this
 */
proto.reportpb.ListActivitySummary.prototype.setTaxWithholding = function(value) {
  return jspb.Message.setProto3StringField(this, 10, value);
};


/**
 * repeated string other_fee_types = 11;
 * @return {!Array<string>}
 */
proto.reportpb.ListActivitySummary.prototype.getOtherFeeTypesList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 11));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.reportpb.ListActivitySummary} returns this
 */
proto.reportpb.ListActivitySummary.prototype.setOtherFeeTypesList = function(value) {
  return jspb.Message.setField(this, 11, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.reportpb.ListActivitySummary} returns this
 */
proto.reportpb.ListActivitySummary.prototype.addOtherFeeTypes = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 11, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.reportpb.ListActivitySummary} returns this
 */
proto.reportpb.ListActivitySummary.prototype.clearOtherFeeTypesList = function() {
  return this.setOtherFeeTypesList([]);
};


/**
 * repeated string other_fee_values = 12;
 * @return {!Array<string>}
 */
proto.reportpb.ListActivitySummary.prototype.getOtherFeeValuesList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 12));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.reportpb.ListActivitySummary} returns this
 */
proto.reportpb.ListActivitySummary.prototype.setOtherFeeValuesList = function(value) {
  return jspb.Message.setField(this, 12, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.reportpb.ListActivitySummary} returns this
 */
proto.reportpb.ListActivitySummary.prototype.addOtherFeeValues = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 12, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.reportpb.ListActivitySummary} returns this
 */
proto.reportpb.ListActivitySummary.prototype.clearOtherFeeValuesList = function() {
  return this.setOtherFeeValuesList([]);
};


/**
 * optional string execution_qty = 13;
 * @return {string}
 */
proto.reportpb.ListActivitySummary.prototype.getExecutionQty = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 13, ""));
};


/**
 * @param {string} value
 * @return {!proto.reportpb.ListActivitySummary} returns this
 */
proto.reportpb.ListActivitySummary.prototype.setExecutionQty = function(value) {
  return jspb.Message.setProto3StringField(this, 13, value);
};


/**
 * optional string execution_net_amt = 14;
 * @return {string}
 */
proto.reportpb.ListActivitySummary.prototype.getExecutionNetAmt = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 14, ""));
};


/**
 * @param {string} value
 * @return {!proto.reportpb.ListActivitySummary} returns this
 */
proto.reportpb.ListActivitySummary.prototype.setExecutionNetAmt = function(value) {
  return jspb.Message.setProto3StringField(this, 14, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.reportpb.UpdateActivityRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.reportpb.UpdateActivityRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.reportpb.UpdateActivityRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.reportpb.UpdateActivityRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    trnsId: jspb.Message.getFieldWithDefault(msg, 1, 0),
    description: jspb.Message.getFieldWithDefault(msg, 2, ""),
    executingVenue: jspb.Message.getFieldWithDefault(msg, 3, ""),
    price: jspb.Message.getFieldWithDefault(msg, 4, ""),
    internalNote: jspb.Message.getFieldWithDefault(msg, 5, ""),
    isArchived: jspb.Message.getBooleanFieldWithDefault(msg, 6, false),
    status: jspb.Message.getFieldWithDefault(msg, 7, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.reportpb.UpdateActivityRequest}
 */
proto.reportpb.UpdateActivityRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.reportpb.UpdateActivityRequest;
  return proto.reportpb.UpdateActivityRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.reportpb.UpdateActivityRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.reportpb.UpdateActivityRequest}
 */
proto.reportpb.UpdateActivityRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setTrnsId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setDescription(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setExecutingVenue(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setPrice(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setInternalNote(value);
      break;
    case 6:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIsArchived(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.setStatus(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.reportpb.UpdateActivityRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.reportpb.UpdateActivityRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.reportpb.UpdateActivityRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.reportpb.UpdateActivityRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTrnsId();
  if (f !== 0) {
    writer.writeUint32(
      1,
      f
    );
  }
  f = message.getDescription();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getExecutingVenue();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getPrice();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getInternalNote();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getIsArchived();
  if (f) {
    writer.writeBool(
      6,
      f
    );
  }
  f = message.getStatus();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
};


/**
 * optional uint32 trns_id = 1;
 * @return {number}
 */
proto.reportpb.UpdateActivityRequest.prototype.getTrnsId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.reportpb.UpdateActivityRequest} returns this
 */
proto.reportpb.UpdateActivityRequest.prototype.setTrnsId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional string description = 2;
 * @return {string}
 */
proto.reportpb.UpdateActivityRequest.prototype.getDescription = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.reportpb.UpdateActivityRequest} returns this
 */
proto.reportpb.UpdateActivityRequest.prototype.setDescription = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string executing_venue = 3;
 * @return {string}
 */
proto.reportpb.UpdateActivityRequest.prototype.getExecutingVenue = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.reportpb.UpdateActivityRequest} returns this
 */
proto.reportpb.UpdateActivityRequest.prototype.setExecutingVenue = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string price = 4;
 * @return {string}
 */
proto.reportpb.UpdateActivityRequest.prototype.getPrice = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.reportpb.UpdateActivityRequest} returns this
 */
proto.reportpb.UpdateActivityRequest.prototype.setPrice = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string internal_note = 5;
 * @return {string}
 */
proto.reportpb.UpdateActivityRequest.prototype.getInternalNote = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.reportpb.UpdateActivityRequest} returns this
 */
proto.reportpb.UpdateActivityRequest.prototype.setInternalNote = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional bool is_archived = 6;
 * @return {boolean}
 */
proto.reportpb.UpdateActivityRequest.prototype.getIsArchived = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 6, false));
};


/**
 * @param {boolean} value
 * @return {!proto.reportpb.UpdateActivityRequest} returns this
 */
proto.reportpb.UpdateActivityRequest.prototype.setIsArchived = function(value) {
  return jspb.Message.setProto3BooleanField(this, 6, value);
};


/**
 * optional string status = 7;
 * @return {string}
 */
proto.reportpb.UpdateActivityRequest.prototype.getStatus = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/**
 * @param {string} value
 * @return {!proto.reportpb.UpdateActivityRequest} returns this
 */
proto.reportpb.UpdateActivityRequest.prototype.setStatus = function(value) {
  return jspb.Message.setProto3StringField(this, 7, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.reportpb.UpdateActivityResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.reportpb.UpdateActivityResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.reportpb.UpdateActivityResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.reportpb.UpdateActivityResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    activity: (f = msg.getActivity()) && proto.reportpb.Activity.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.reportpb.UpdateActivityResponse}
 */
proto.reportpb.UpdateActivityResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.reportpb.UpdateActivityResponse;
  return proto.reportpb.UpdateActivityResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.reportpb.UpdateActivityResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.reportpb.UpdateActivityResponse}
 */
proto.reportpb.UpdateActivityResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.reportpb.Activity;
      reader.readMessage(value,proto.reportpb.Activity.deserializeBinaryFromReader);
      msg.setActivity(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.reportpb.UpdateActivityResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.reportpb.UpdateActivityResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.reportpb.UpdateActivityResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.reportpb.UpdateActivityResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getActivity();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.reportpb.Activity.serializeBinaryToWriter
    );
  }
};


/**
 * optional Activity activity = 1;
 * @return {?proto.reportpb.Activity}
 */
proto.reportpb.UpdateActivityResponse.prototype.getActivity = function() {
  return /** @type{?proto.reportpb.Activity} */ (
    jspb.Message.getWrapperField(this, proto.reportpb.Activity, 1));
};


/**
 * @param {?proto.reportpb.Activity|undefined} value
 * @return {!proto.reportpb.UpdateActivityResponse} returns this
*/
proto.reportpb.UpdateActivityResponse.prototype.setActivity = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.reportpb.UpdateActivityResponse} returns this
 */
proto.reportpb.UpdateActivityResponse.prototype.clearActivity = function() {
  return this.setActivity(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.reportpb.UpdateActivityResponse.prototype.hasActivity = function() {
  return jspb.Message.getField(this, 1) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.reportpb.ListActivitiesResponse.repeatedFields_ = [1,2];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.reportpb.ListActivitiesResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.reportpb.ListActivitiesResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.reportpb.ListActivitiesResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.reportpb.ListActivitiesResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    activitiesList: jspb.Message.toObjectList(msg.getActivitiesList(),
    proto.reportpb.Activity.toObject, includeInstance),
    otherFeeTypesList: (f = jspb.Message.getRepeatedField(msg, 2)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.reportpb.ListActivitiesResponse}
 */
proto.reportpb.ListActivitiesResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.reportpb.ListActivitiesResponse;
  return proto.reportpb.ListActivitiesResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.reportpb.ListActivitiesResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.reportpb.ListActivitiesResponse}
 */
proto.reportpb.ListActivitiesResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.reportpb.Activity;
      reader.readMessage(value,proto.reportpb.Activity.deserializeBinaryFromReader);
      msg.addActivities(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.addOtherFeeTypes(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.reportpb.ListActivitiesResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.reportpb.ListActivitiesResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.reportpb.ListActivitiesResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.reportpb.ListActivitiesResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getActivitiesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.reportpb.Activity.serializeBinaryToWriter
    );
  }
  f = message.getOtherFeeTypesList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      2,
      f
    );
  }
};


/**
 * repeated Activity activities = 1;
 * @return {!Array<!proto.reportpb.Activity>}
 */
proto.reportpb.ListActivitiesResponse.prototype.getActivitiesList = function() {
  return /** @type{!Array<!proto.reportpb.Activity>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.reportpb.Activity, 1));
};


/**
 * @param {!Array<!proto.reportpb.Activity>} value
 * @return {!proto.reportpb.ListActivitiesResponse} returns this
*/
proto.reportpb.ListActivitiesResponse.prototype.setActivitiesList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.reportpb.Activity=} opt_value
 * @param {number=} opt_index
 * @return {!proto.reportpb.Activity}
 */
proto.reportpb.ListActivitiesResponse.prototype.addActivities = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.reportpb.Activity, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.reportpb.ListActivitiesResponse} returns this
 */
proto.reportpb.ListActivitiesResponse.prototype.clearActivitiesList = function() {
  return this.setActivitiesList([]);
};


/**
 * repeated string other_fee_types = 2;
 * @return {!Array<string>}
 */
proto.reportpb.ListActivitiesResponse.prototype.getOtherFeeTypesList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 2));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.reportpb.ListActivitiesResponse} returns this
 */
proto.reportpb.ListActivitiesResponse.prototype.setOtherFeeTypesList = function(value) {
  return jspb.Message.setField(this, 2, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.reportpb.ListActivitiesResponse} returns this
 */
proto.reportpb.ListActivitiesResponse.prototype.addOtherFeeTypes = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 2, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.reportpb.ListActivitiesResponse} returns this
 */
proto.reportpb.ListActivitiesResponse.prototype.clearOtherFeeTypesList = function() {
  return this.setOtherFeeTypesList([]);
};


goog.object.extend(exports, proto.reportpb);
